<template>
<div>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>
  <div class="row">
    <div class="col">

      <card style="min-height: 150px;">
        <div class="row">
          <div class="col">
            <div
              class="btn-group btn-group-toggle"
              :class="'float-left'"
              data-toggle="buttons"
            >
              <label
                v-for="(option, index) in categories"
                :key="index + j"
                class="btn btn-sm btn-primary btn-simple"
                :class="{ active: option.active }"
                :id="index"
              >
                <input
                  type="radio"
                  @click="switchTab(index)"
                  name="options"
                  autocomplete="off"
                  :checked="option.active"
                />
                <span style="font-size: medium; font-weight: lighter"  class="d-none d-sm-block">{{ option.name }}</span>
                <span class="d-block d-sm-none">
                    <i :class="option.icon"></i>
                  </span>
              </label>
            </div>
          </div>
          <div class="col d-sm-none d-block text-right">
            <base-button :style="{'font-size': 'x-large', 'font-weight': 'bold'}" icon class="btn btn-link" type="primary" v-on:click="addAnotherBooking()">
              <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}"  class="tim-icons el-icon-back"></i>
            </base-button>
          </div>
          <div class="col d-sm-block d-none  text-right">
            <base-button simple size="sm" type="primary" v-on:click="addAnotherBooking()"> + Add another booking</base-button>
          </div>
        </div>

<!--        Basket-->
        <div v-if="activeTabIndex === 0 && cart.length <= 0" class="mt-3" >
          <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
            <h4 class="mt-3">No items in basket.</h4>
          </div>
        </div>

        <div v-if="activeTabIndex === 0 && cart.length > 0" class="row mt-3" >
          <div class="col d-sm-block d-none">
            <b-table :items="cart" :fields="cartFields">
              <template v-slot:cell(booking)="row">
                <div class="row">
                  <div class="col-2 mt-1">
                    <img :src="row.item.url"/>
                  </div>
                  <div class="col-5">
                    <div class="row">
                      <div class="col">
                        <span style="font-size: medium">{{row.item.game_name}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                      <span>
                        <i class="tim-icons icon-calendar-60 mr-1 text-primary"></i>
                        <span class="mr-2">{{getBookingDate(row.item.booking_date)}}</span>
                        <i class="tim-icons icon-time-alarm mr-1 text-primary"></i>
                        <span v-if="row.item.start_time.includes('M')">{{row.item.start_time}}</span>
                        <span v-else>{{getTime(row.item.start_time)}}</span>

                      </span>
                      </div>
                    </div>
                    <div v-if="hasDurationPicker(row.item)" class="row mt-2">
                      <div class="col">
                        <label class="text-white d-block mb-1">Duration</label>
                        <segmented-toggle variant="pills" size="sm" :value="row.item.selected_duration_id" :options="durationOptionsFor(row.item)" :disabled="!!price_override[row.index]" @input="v => onDurationChange(row.item, v)" />
                      </div>
                    </div>

                  </div>
                </div>
              </template>
              <template v-slot:cell(number_of_players)="row">
                <div class="row" v-for="(c, i) in row.item.tickets" :key="'C' + i" v-if="!price_override[row.index]">
                  <div class="col-lg-6">
                    <label class="text-primary text-uppercase">{{c.category}}</label>
                    <base-input>
                      <el-input-number @change="onPlayerCountChange(row.item)" v-model="c.number_of_players" :min="0" />
                    </base-input>

                  </div>
                </div>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(price)="row">
                <div v-if="!price_override[row.index]">
                  <h2 style="margin-bottom: 0px" class="warning" v-if="hasInclusiveTaxes"> {{getAmount(row.item.computed_total)}}</h2>
                  <h2 style="margin-bottom: 0px" class="warning" v-else> {{getAmount(row.item.total)}}</h2>
                  <small>
                    <div class="text-primary" v-for="(c, i) in row.item.tickets" :key="'CC' + i">
                      <span v-if="row.item.pricing_type_id === 1">{{getAmount(getRate(c, row.item))}} per {{c.category}}</span>
                      <span v-if="row.item.pricing_type_id === 2">{{getRate(c, row.item)}}</span>
                    </div>
                  </small>

                  <base-button v-if="row.item.tickets.length > 0" class="mt-2"
                               size="sm" type="primary" v-on:click="overridePrice(row.item.tickets, row.index, row.item)">Override price</base-button>
                </div>
                <div v-else>
                  <div style="max-width: 70%" v-for="(c, index) in row.item.tickets" :key="'CCOVERRIDE' + index">
                    <label v-if="row.item.pricing_type_id === 1">Price per {{c.category}} ({{currency_symbol}})</label>
                    <label v-if="row.item.pricing_type_id === 2">Price for {{c.category}} ({{currency_symbol}})</label>
                    <div class="row">
                      <div class="col">
                        <base-input>
                          <el-input-number placeholder="0.00" v-model="c.price" :controls="false" :precision="2" :step="0.1" />
                        </base-input>
                      </div>
                      <div class="col">
                        <small class="text-white mr-2">Original price: {{getAmount(c.original_price)}}</small>
                        <el-tooltip class="d-inline"
                                    content="Set to original price"
                                    effect="light"
                                    :open-delay="300"
                                    placement="right"
                        >
                          <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" v-on:click="setOriginalPrice(c)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <base-button size="sm" type="primary" v-on:click="saveOverride(row.item.tickets, row.index, row.item)">Save</base-button>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div style="min-width: 100px">
                  <el-tooltip content="Delete booking"
                              effect="light"
                              :open-delay="300"
                              placement="top">
                    <base-button
                      @click="deleteBooking(row.index)"
                      simple
                      type="danger"
                      link
                    > <i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </template>

            </b-table>
          </div>
<!--          Mobile-->
          <div class="col d-sm-none d-block">
            <b-table :items="cart" :fields="cartFieldsMobile">
              <template v-slot:cell(cart)="row">
                <div class="row">
                  <div class="col-3 mt-1">
                    <img :src="row.item.url"/>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col">
                        <span style="font-size: medium">{{row.item.game_name}}</span>
                      </div>
                      <div class="col text-right">
                        <base-button
                                     @click="deleteBooking(row.index)"
                                     simple
                                     type="danger"
                                     link
                        > <i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                      <span>
                        <i class="tim-icons icon-calendar-60 mr-1 text-primary"></i>
                        <span class="mr-2">{{getBookingDate(row.item.booking_date)}}</span>
                        <i class="tim-icons icon-time-alarm mr-1 text-primary"></i>
                        <span v-if="row.item.start_time.includes('M')">{{row.item.start_time}}</span>
                        <span v-else>{{getTime(row.item.start_time)}}</span>
                      </span>
                      </div>
                    </div>
                    <div v-if="hasDurationPicker(row.item)" class="row mt-2">
                      <div class="col">
                        <label class="text-white d-block mb-1">Duration</label>
                        <segmented-toggle variant="pills" size="sm" :value="row.item.selected_duration_id" :options="durationOptionsFor(row.item)" :disabled="!!price_override[row.index]" @input="v => onDurationChange(row.item, v)" />
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col">
                        <span v-if="!editing[row.index]">Booked for x{{row.item.group_size}} people</span>
                        <label v-if="editing[row.index]">Group size</label>
                        <base-input v-if="editing[row.index]" type="number" style="width: 50%" v-model="row.item.group_size"></base-input>
                        <small v-if="row.item.group_size <= 0" class="text-danger">Group size must be greater than 0</small>
                      </div>
                    </div>

                    <div class="row" v-for="(c, i) in row.item.tickets" :key="'C' + i" v-if="!price_override[row.index]">
                      <div class="col-lg-6">
                        <label class="text-primary text-uppercase">{{c.category}}</label>
                        <base-input>
                          <el-input-number @change="onPlayerCountChange(row.item)" v-model="c.number_of_players" :min="0" />
                        </base-input>

                      </div>
                    </div>
                    <span v-else>-</span>

                    <div class="row mt-2">
                      <div class="col">
                        <div v-if="!price_override[row.index]">
                          <h2 style="margin-bottom: 0px" class="warning">{{getAmount(row.item.total)}}</h2>
                          <small>
                            <div class="text-primary" v-for="(c, i) in row.item.tickets" :key="'CC' + i">
                              <span v-if="row.item.pricing_type_id === 1">{{getAmount(getRate(c, row.item))}} per {{c.category}}</span>
                              <span v-if="row.item.pricing_type_id === 2">{{getRate(c, row.item)}}</span>
                            </div>
                          </small>

                          <base-button v-if="row.item.tickets.length > 0" class="mt-2"
                                       size="sm" type="primary" v-on:click="overridePrice(row.item.tickets, row.index, row.item)">Override price</base-button>
                        </div>
                        <div v-else>
                          <div style="max-width: 90%" v-for="(c, index) in row.item.tickets" :key="'CCOVERRIDE' + index">
                            <label v-if="row.item.pricing_type_id === 1">Price per {{c.category}} ({{currency_symbol}})</label>
                            <label v-if="row.item.pricing_type_id === 2">Price for {{c.category}} ({{currency_symbol}})</label>
                            <div class="row">
                              <div class="col">
                                <base-input>
                                  <el-input-number placeholder="0.00" v-model="c.price" :controls="false" :precision="2" :step="0.1" />
                                </base-input>
                              </div>
                              <div class="col">
                                <small class="text-white mr-2">Original price: {{getAmount(c.original_price)}}</small>
                                <el-tooltip class="d-inline"
                                            content="Set to original price"
                                            effect="light"
                                            :open-delay="300"
                                            placement="right"
                                >
                                  <i style="cursor: pointer" class="ml-1 tim-icons icon-refresh-02 text-white" v-on:click="setOriginalPrice(c)"></i>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                          <base-button size="sm" type="primary" v-on:click="saveOverride(row.item.tickets, row.index, row.item)">Save</base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

            </b-table>
          </div>
        </div>

<!--        Customer-->
        <div v-if="activeTabIndex === 1" class="row mt-3" >
          <div class="col">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <base-input label="Customer lookup (search by name, email, or phone number)">
                  <el-autocomplete style="width: 100%"
                    v-model="lookup_value"
                    :fetch-suggestions="querySearch"
                    placeholder="Search"
                    :trigger-on-focus="false"
                     @select="handleSelect"
                  >
                    <template #default="{ item }">
                      <p style="margin-bottom: -12px" class="text-primary">{{ item.first_name }} {{ item.last_name }}</p>
                      <small class="font-italic">
                        <i class="tim-icons icon-email-85"></i> {{item.email }} &nbsp;
                        <i v-if="item.phone" class="tim-icons el-icon-mobile-phone"></i> {{item.phone }}
                      </small>

                    </template>
                  </el-autocomplete>
                </base-input>
              </div>
              <div class="col">
                <base-button class="d-sm-none d-block" size="sm" simple type="primary" v-on:click="clearCustomer()">Clear</base-button>
                <base-input label=" ">
                  <base-button class="d-sm-block d-none" simple type="primary" v-on:click="clearCustomer()">Clear</base-button>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <base-input :error="errs.first_name" label="First name *" v-model="user.first_name" v-on:change="updateCustomer()" placeholder="First name"></base-input>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <base-input :error="errs.last_name" v-on:change="updateCustomer()" label="Last name *" v-model="user.last_name" placeholder="Last name"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <base-input :error="errs.email" label="Email *" v-on:change="updateCustomer()" v-on:input="errs.email = ''" v-model="user.email" placeholder="Email"></base-input>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <base-input v-on:change="updateCustomer()"
                  type="text"
                  :label="isPhoneRequired() ? 'Phone *' : 'Phone (optional)'"
                  :error="errs.phone">
                  <phone-number-input ref="phoneInput"
                                      v-model="user.phone" @phone-update="handlePhoneUpdate"
                                      @input="errs.phone = ''"
                                      :default-country="countryCode || 'US'"
                  />
                </base-input>
              </div>
            </div>

            <div class="row mt-4 mb-4" v-if="loadingCustomFields || visibleCustomFields.length > 0">
              <div class="col-lg-6 col-12">
                <p class="text-uppercase text-white">Additional info</p>
                <custom-field-response-renderer
                  ref="cfRenderer"
                  :fields="visibleCustomFields"
                  v-model="customFieldResponses"
                  :disabled="loading"
                  :loading="loadingCustomFields"
                />
              </div>
            </div>
          </div>

        </div>

  <!--        Payments-->
        <!-- v-show (not v-if) so the Stripe Card Element iframe stays mounted across
             tab switches. Custom-field and phone validation in createBooking() temporarily
             switch to tab 1, which would otherwise destroy the iframe and lose user input. -->
        <div v-show="activeTabIndex === 2" class="row mt-3" >
          <div class="col">
            <div v-if="errs.payment" role="alert" class="payment-inline-alert mb-3">
              <i class="tim-icons icon-alert-circle-exc mr-2"></i>
              <span>{{ errs.payment }}</span>
            </div>
            <div class="row">
              <div class="col">
                <base-button v-if="add_payment == false" simple v-on:click="addPaymentNow()" size="sm" type="primary">Add payment</base-button>
                <base-button v-if="add_payment == true" simple v-on:click="payOnArrival()" size="sm" type="primary">Pay on arrival</base-button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-checkbox v-model="no_confirmation_email">Do not send automated emails to the customer for this booking</base-checkbox>
                <base-checkbox :disabled="add_payment && !(pay_partial_amount && parseFloat(partial_amount) < total)" v-model="send_payment_request">Send payment request email to customer</base-checkbox>
                <base-checkbox v-on:input="setPartialAmount()" v-if="add_payment == true && selectedPaymentOption.name !== 'Customer credit'" v-model="pay_partial_amount">Pay partial amount</base-checkbox>

              </div>
            </div>
            <div class="row mt-2" v-if="add_payment && pay_partial_amount && selectedPaymentOption.name !== 'Customer credit'">
              <div class="col-lg-3">
                <base-input :error="errs.partial_amount" :key="pa_key" v-model="partial_amount" placeholder="0.00" :label="'Amount (' + currency_symbol + ')'"></base-input>
              </div>
            </div>

            <div class="row mt-2" v-if="add_payment">
              <div class="col-lg-4">
                <base-input label="Promo code">
                  <el-autocomplete style="width: 100%"
                                   v-model="promo_code"
                                   :fetch-suggestions="promoSearch"
                                   placeholder="Search by code..."
                                   :trigger-on-focus="false"
                                   @select="handlePromoSelect"
                  >
                    <template #default="{ item }">
                      <div class="row">
                        <div class="col">
                          <div>
                            <span class="text-primary">{{ item.name }}</span>
                            <span v-if="!hasBuyXGetYRule(item.rules)"> - </span>
                            <small>
                              <template v-if="!hasBuyXGetYRule(item.rules)">
                                <span v-if="item.redemption_type === 0">{{item.value_amount}}%</span>
                                <span v-if="item.redemption_type === 1">{{getAmount(item.value_amount)}}</span>
                                <span v-if="item.value_type === 0"> per transaction</span>
                                <span v-if="item.value_type === 1"> per line item</span>
                                <span v-if="item.value_type === 2"> per quantity</span>
                              </template>
                              <span class="ml-2"
                                    style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                           color: white; background-color: #1d8cf8; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                    v-if="hasBuyXGetYRule(item.rules)">buy x get y</span>
                              <span class="ml-2"
                                    style="text-transform: uppercase; line-height: 9px; text-decoration: none; border: none;
                                           color: white; background-color: #344675; border-radius: 2px; padding: 2px 5px 2px 5px; font-size: 9px"
                                    v-if="item.internal_only">internal only</span>
                            </small>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                </base-input>
              </div>
              <div class="col mt-4">
                <base-button v-on:click="applyPromoCode()" style="padding: -25px" type="primary">Apply</base-button>
                <base-button v-on:click="promo_code = ''" simple style="padding: -25px" type="primary" class="ml-2">Clear</base-button>
              </div>
            </div>
            <div class="row mt-2" v-show="add_payment">
              <div class="col-lg-3 col-md-6 col-12">
                <base-input label="Payment options">
                  <el-select
                    class="select-primary mb-3"
                    v-model="selectedPaymentOption"
                    placeholder="Option"
                    value-key="id"
                  >
                    <el-option
                      class="select-primary"
                      v-for="(item, index) in paymentOptions"
                      :key="index + 'P'"
                      :label="item.name"
                      :value="{id: item.id, name: item.name, content: item.content, is_default: item.is_default}"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <!-- Stripe stored cards dropdown (same row as payment options) -->
              <div class="col-lg-3 col-md-6 col-12" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 3 && payment_settings.store_credit_card && stripe_payment_methods.length > 0">
                <base-input label="Stored cards">
                  <el-select
                    class="select-primary mb-3"
                    v-model="selected_payment_method"
                    placeholder="Select card"
                    @change="onPaymentMethodChange"
                  >
                    <el-option class="select-primary" label="Use a new card" value="new"></el-option>
                    <el-option
                      class="select-primary"
                      v-for="pm in stripe_payment_methods"
                      :key="pm.id"
                      :label="getCardBrandName(pm.card_brand) + ' ****' + pm.card_last_four + (pm.is_default ? ' (Default)' : '')"
                      :value="pm.id"
                    >
                      <span>
                        <i :class="getCardBrandIcon(pm.card_brand)" class="mr-2"></i>
                        {{ getCardBrandName(pm.card_brand) }} ****{{ pm.card_last_four }}
                        <badge v-if="pm.is_default" type="success" class="ml-2">Default</badge>
                      </span>
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <!-- Square stored cards dropdown (same row as payment options) -->
              <div class="col-lg-3 col-md-6 col-12" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 2 && payment_settings.square_store_credit_card && square_payment_methods.length > 0">
                <base-input label="Stored cards">
                  <el-select
                    class="select-primary mb-3"
                    v-model="selected_payment_method"
                    placeholder="Select card"
                    @change="onSquarePaymentMethodChange"
                  >
                    <el-option class="select-primary" label="Use a new card" value="new"></el-option>
                    <el-option
                      class="select-primary"
                      v-for="pm in square_payment_methods"
                      :key="pm.id"
                      :label="getCardBrandName(pm.card_brand) + ' ****' + pm.card_last_four + (pm.is_default ? ' (Default)' : '')"
                      :value="pm.id"
                    >
                      <span>
                        <i :class="getCardBrandIcon(pm.card_brand)" class="mr-2"></i>
                        {{ getCardBrandName(pm.card_brand) }} ****{{ pm.card_last_four }}
                        <badge v-if="pm.is_default" type="success" class="ml-2">Default</badge>
                      </span>
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="!selectedPaymentOption.is_default">
              <div class="col">
                <div v-html="selectedPaymentOption.content"></div>
              </div>
            </div>

            <div class="row" v-show="selectedPaymentOption.name === 'Customer credit' && add_payment">
              <div class="col-lg-3 col-md-3 col-6">
                <base-input label="Available ($)" v-model="available_credit" disabled></base-input>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                <base-input label="Amount to apply($)" v-model="applied_credit"></base-input>
              </div>
            </div>

            <div class="row" v-show="add_payment == true && selectedPaymentOption.name === 'Gift card' && selectedGiftCardCode">
              <div class="col-lg-2 col-md-3 col-6">
                <base-input label="Available balance ($)" v-model="selectedGiftCardCode.remaining" disabled></base-input>
              </div>
            </div>

            <div class="row mb-3" v-show="add_payment === true && selectedPaymentOption.name === 'Gift card'">
              <div class="col-lg-6">
                <base-input label="Gift card code" :error="errs.gift_card_code">
                  <el-autocomplete style="width: 100%"
                                   v-model="gift_card_code"
                                   :fetch-suggestions="giftCardSearch"
                                   placeholder="Search by code..."
                                   :trigger-on-focus="false"
                                   @select="handleGiftCardSelect"
                  >
                    <template #default="{ item }">
                      <div class="row">
                        <div class="col">
                          <p style="margin-bottom: -12px" class="text-primary">{{ getGiftCardCode(item.code) }}</p>
                          <small class="font-italic">
                            <i class="tim-icons icon-money-coins"></i> Total {{getAmount(item.total)}} Remaining {{getAmount(item.remaining)}}
                          </small>
                          <br/>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                </base-input>
              </div>
            </div>

            <!--                  Square-->
            <div class="mb-5" v-show="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 2 && add_payment">
              <!-- Square stored card display -->
              <div class="row mb-3" v-if="payment_settings.square_store_credit_card && selected_payment_method !== 'new' && selectedSquareStoredCard">
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="card p-3 mb-0 stored-card" style="background: linear-gradient(135deg, #171826 0%, #2d2d44 100%); border: 2px solid #e14eca40;">
                    <div class="d-flex align-items-center">
                      <i :class="getCardBrandIcon(selectedSquareStoredCard.card_brand)" class="text-white mr-3" style="font-size: 2rem;"></i>
                      <div>
                        <p class="text-white mb-0">{{ getCardBrandName(selectedSquareStoredCard.card_brand) }} ****{{ selectedSquareStoredCard.card_last_four }}</p>
                        <small class="text-white opacity-7" v-if="selectedSquareStoredCard.cardholder_name">{{ selectedSquareStoredCard.cardholder_name }}</small>
                        <small class="text-white opacity-7"> &middot; Expires {{ selectedSquareStoredCard.card_exp_month }}/{{ selectedSquareStoredCard.card_exp_year }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Square new card form -->
              <div class="row" v-show="selected_payment_method === 'new' || square_payment_methods.length === 0">
                <div class="col-lg-6 col-md-6 col-12">
                  <form id="payment-form-square" class="form-group has-label">
                    <label for="card-container">
                      Credit or debit card
                    </label>
                    <div id="card-container"></div>
                  </form>
                  <div id="payment-status-container"></div>
                </div>
              </div>

              <!-- Square save card toggle -->
              <div class="row mt-4" v-if="showSquareStoreCreditCardOption()">
                <div class="col">
                  <el-switch active-color="#e14eca" v-model="save_card_for_future"/>
                  <label class="ml-2">Save card for future payments</label>
                </div>
              </div>
            </div>

            <!--        Stripe-->
            <div class="mb-5" v-show="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 3 && add_payment">
              <!-- Stored card display -->
              <div class="row mb-3" v-if="payment_settings.store_credit_card && selected_payment_method !== 'new' && selectedStoredCard">
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="card p-3 mb-0 stored-card" style="background: linear-gradient(135deg, #171826 0%, #2d2d44 100%); border: 2px solid #e14eca40;">
                    <div class="d-flex align-items-center">
                      <i :class="getCardBrandIcon(selectedStoredCard.card_brand)" class="text-white mr-3" style="font-size: 2rem;"></i>
                      <div>
                        <p class="text-white mb-0">{{ getCardBrandName(selectedStoredCard.card_brand) }} ****{{ selectedStoredCard.card_last_four }}</p>
                        <small class="text-white opacity-7" v-if="selectedStoredCard.cardholder_name">{{ selectedStoredCard.cardholder_name }}</small>
                        <small class="text-white opacity-7"> &middot; Expires {{ selectedStoredCard.card_exp_month }}/{{ selectedStoredCard.card_exp_year }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- New card form -->
              <div class="row" v-show="selected_payment_method === 'new' || stripe_payment_methods.length === 0">
                <div class="col-lg-6 col-md-6 col-12">
                  <form id="payment-form" class="form-group has-label" :class="{ 'has-danger': card_error_message }">
                    <label for="card-element">
                      Credit or debit card
                    </label>
                    <div id="card-element">
                      <!-- A Stripe Element will be inserted here. -->
                    </div>
                    <label id="card-errors" class="error" role="alert" v-show="card_error_message">{{ card_error_message }}</label>
                  </form>
                </div>
              </div>

              <!-- Save card option -->
              <div class="row mt-4" v-if="showStoreCreditCardOption()">
                <div class="col">
                  <el-switch active-color="#e14eca" v-model="save_card_for_future"/>
                  <label class="ml-2">Save card for future payments</label>
                </div>
              </div>
            </div>

            <div class="row" v-if="selectedPaymentOption.name === 'Card' && payment_settings.payment_gateway_id === 1 && add_payment">
              <div class="col-12">
                <div class="authorize-form-wrapper">
                  <enhanced-payment-form
                    ref="authorizePaymentForm"
                    :api-login-id="payment_settings.api_name"
                    :public-client-key="payment_settings.public_client_key"
                    :is-live="!!payment_settings.is_live"
                    :show-security-indicators="false"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
<!--Complete transaction-->
        <div class="row justify-content-end">
          <div class="col text-right waive-toggle-row">
            <template v-if="taxes.length > 0">
              <el-switch v-model="waive_tax" @change="waiveTaxes()" active-color="#e14eca" />
              <span class="ml-2 text-white">Waive taxes</span>
            </template>
            <el-switch v-model="waive_fee" @change="recalculateDiscount()" active-color="#e14eca" class="ml-3" />
            <span class="ml-2 text-white">Waive fees</span>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col text-right">
            <hr style="border-top: 1px solid #f4f5f7;">
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title text-white text-uppercase">Subtotal</h4>
              </div>
              <div class="col text-right">
                <h4 class="text-white"><span class="text-uppercase">
                   {{getAmount(subtotal)}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-end" v-for="(p, i) in promos" :key="pc_key + i">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-8">
                <h4 class="text-white card-title"><span class="text-uppercase">
                    {{p.name}}</span>
                  <base-button @click="removePromoCode(p)" style="padding: 0; margin: 0" type="danger" icon class="btn-link d-inline">
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </h4>
              </div>
              <div class="col text-right">
                <!--                <h4 class="card-title text-white" v-if="p.redemption_type === 0"><span class="text-uppercase">-->
                <!--                      -{{getAmount(getDiscount(p.value_amount, subtotal))}}</span>-->
                <!--                </h4>-->
                <h4 class="card-title text-white"><span class="text-uppercase">
                      -{{getAmount(getShelfDiscount(p))}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!waive_tax" class="row justify-content-end" v-for="(t, i) in taxes" :key="'T' + i">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title text-white text-uppercase">{{t.name}}
                  <span v-if="t.pricing_type === 1"> (included)</span>
                </h4>
              </div>
              <div class="col text-right">
                <h4 class="text-white"><span class="text-uppercase">
                   {{getAmount(getTax(t))}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!waive_fee" class="row justify-content-end" v-for="(f, i) in fees" :key="'F' + i">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title text-white text-uppercase">{{f.name}}</h4>
              </div>
              <div class="col text-right">
                <h4 class="text-white"><span class="text-uppercase">
                   {{getAmount(getFee(f))}}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-end" v-if="taxes.length > 0">
          <div class="col d-sm-none d-block text-right">
            <hr style="border-top: 1px solid #f4f5f7;">
          </div>
          <div class="col-6 d-sm-block d-none text-right ">
            <hr style="border-top: 1px solid #f4f5f7;">
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-8">
                <h4 class="card-title text-white text-uppercase">Total</h4>
              </div>
              <div class="col text-right">
                <h4 class="card-title text-white">
                  {{getAmount(getTotal())}}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row d-sm-none d-block">
          <div class="col text-right">
            <base-button v-on:click="cancelTransaction()" type="default">Cancel</base-button>
            <base-button class="ml-2" :disabled="loading" type="primary" v-on:click="createBooking()">Create</base-button>
          </div>
        </div>
        <div class="row justify-content-end d-sm-block d-none">
          <div class="col text-right">
            <base-button v-on:click="cancelTransaction()" type="default">Cancel transaction</base-button>
            <base-button class="ml-2" :disabled="loading || isAnyPriceOverrideOpen" :title="isAnyPriceOverrideOpen ? 'Save or cancel the price override first' : ''" type="primary" v-on:click="createBooking()">Complete transaction</base-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import {formattedDate, time} from "@/plugins/dateFormatter";
import swal from "sweetalert2";
import {Autocomplete} from 'element-ui';
import {API_LOCATION} from "@/api-config";
import {diacriticIncludes} from "@/util/search";
import axios from "axios";
import { buildCustomFieldResponsesPayload, filterCustomFieldsByGames } from '@/util/customFieldValidation';
import { isInternalPhoneRequired, validateInternalCustomerPhone } from '@/util/customerFieldValidation';
import {Auth} from "aws-amplify";
import _ from "lodash";
import currencies from "@/assets/currencies.json";
import countries from "@/assets/countries.json";
import {formatPhoneDisplay} from "@/util/phoneFormatter";
import {isValidEmail} from "@/util/emailValidator";
import PhoneNumberInput from "@/components/PhoneNumberInput";
import EnhancedPaymentForm from "@/components/Payments/EnhancedPaymentForm";
import { roundCents, slotDurationSettings, durationPickerOptions, slotPricingRows } from '@/util/pricing'


export default {
  name: "NewTransaction",
  components: {
    BTable,
    [Autocomplete.name]: Autocomplete,
    PhoneNumberInput,
    EnhancedPaymentForm
  },
  computed: {
    isAnyPriceOverrideOpen() {
      return this.price_override.some(v => v === true);
    },
    cartGameIds() {
      return (this.cart || [])
        .map(c => c && c.game_id)
        .filter(id => id != null);
    },
    visibleCustomFields() {
      return filterCustomFieldsByGames(this.internalCustomFields, this.cartGameIds);
    },
    categories() {
      return [{ name: 'Basket', icon: 'tim-icons icon-cart', active: true },
        { name: 'Customers', icon: 'tim-icons  icon-single-02', active: false },
        { name: 'Payment', icon: 'tim-icons  icon-money-coins', active: false },
      ];
    },
    hasInclusiveTaxes() {
      for (let n in this.taxes) {
        if (this.taxes[n].pricing_type === 1) {
          return true
        }
      }
      return false
    }
  },
  data() {
    return {
      internalCustomFields: [],
      customFieldResponses: {},
      loadingCustomFields: false,
      countryCode: JSON.parse(localStorage.getItem('company')).country,
      selectedGiftCardCode: '',
      gift_card_code: '',
      no_confirmation_email: false,
      waive_fee: false,
      waive_tax: false,
      country: '',
      countries: countries.countries,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      currencies: currencies.currencies,
      lookup_value: '',
      loading: false,
      cart: [],
      taxes: [],
      fees: [],
      subtotal: 0,
      total_tax: 0,
      total_fee: 0,
      total: 0,
      activeTabIndex: 0,
      selectedPaymentOption: {name: '', content: '', id: '', is_default: ''},
      paymentOptions: [],
      cartFields: ["booking", "number_of_players", "price", "actions"],
      cartFieldsMobile: ['cart'],
      available_credit: 0,
      applied_credit: 0,
      j: 0,
      editing: [],
      price_override: [],
      payment: {
        cardNumber: '',
        expirationDate: '',
        cardCode: '',
        zip: ''
      },
      authorize_opaque_data: null,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phoneE164: '',
        end_user_id: null
      },
      // Stripe stored payment methods
      stripe_customer: null,
      stripe_payment_methods: [],
      // Square stored payment methods
      square_customer: null,
      square_payment_methods: [],
      selectedSquareStoredCard: null,
      selected_payment_method: 'new',
      selectedStoredCard: null,
      save_card_for_future: false,
      errs: {
        gift_card_code: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        ccn: '',
        cvv: '',
        zip: '',
        expiration: '',
        payment: ''
      },
      card: '',
      square: '',
      squareAppId: '',
      squareLocationId: '',
      elements: '',
      stripe: '',
      payment_settings: '',
      add_payment: true,
      card_complete: false,
      card_error_message: '',
      currency: JSON.parse(localStorage.getItem('group')).currency,
      currency_symbol: '$',
      number_format: JSON.parse(localStorage.getItem('group')).number_format,
      currency_format: JSON.parse(localStorage.getItem('group')).currency_format,
      send_payment_request: false,
      pay_partial_amount: false,
      partial_amount: 0,
      pa_key: 0,
      promos: [],
      promo_code: '',
      selectedPromoCode: '',
      pc_key: 0,
    }
  },
  methods: {
    isPhoneRequired() {
      try {
        return isInternalPhoneRequired(JSON.parse(localStorage.getItem('group') || '{}'));
      } catch (e) {
        return false;
      }
    },

    formatPhone(country, phone) {
      return formatPhoneDisplay(phone, country || 'US');
    },
    handlePhoneUpdate(phoneData) {
      this.user.phoneE164 = phoneData.e164;
    },
    waiveTaxes(){
      // Recalculate taxes fresh so cart[n].tax values are current
      this.getSubTotal()
      this.getTaxes()
      if(this.hasInclusiveTaxes){
        let new_subtotal = 0
        for(let n in this.cart){
          if(this.waive_tax){
            this.cart[n].computed_total = roundCents(parseFloat(this.cart[n].total - this.cart[n].tax))
          } else {
            this.cart[n].computed_total = this.cart[n].total
          }
          new_subtotal += this.cart[n].computed_total
        }
        this.subtotal = roundCents(parseFloat(new_subtotal))
      }
      this.getFees()
      this.getTotal()
    },
    payOnArrival() {
      this.pay_partial_amount = false
      this.add_payment = false
      this.errs.payment = ''
    },
    addPaymentNow(){
      this.add_payment = true
      this.send_payment_request = false
      this.errs.payment = ''
    },
    overridePrice(pricing_categories, index, item){
      for(let n in pricing_categories){
        if(item.cumulative_category_pricing){
          //Price
          if(!pricing_categories[n].hasOwnProperty('original_price')){
            for(let m in pricing_categories[n].category_pricing){
              if(item.group_size >= pricing_categories[n].category_pricing[m].min_players
                && item.group_size <= pricing_categories[n].category_pricing[m].max_players){
                pricing_categories[n].original_price = pricing_categories[n].category_pricing[m].price
                pricing_categories[n].price = pricing_categories[n].category_pricing[m].price
              }
            }
            let last_index = _.findLastKey(pricing_categories[n].category_pricing)
            if(last_index && item.group_size > pricing_categories[n].category_pricing[last_index].max_players){
              pricing_categories[n].original_price = pricing_categories[n].category_pricing[last_index].price
              pricing_categories[n].price = pricing_categories[n].category_pricing[last_index].price
            }
            let smallest_price_category = _.find(pricing_categories[n].category_pricing)
            if(smallest_price_category && item.number_of_players !== 0 &&
              item.group_size < smallest_price_category.min_players){
              pricing_categories[n].original_price = smallest_price_category.price
              pricing_categories[n].price = smallest_price_category.price
            }
          }
          //Original price
          if(pricing_categories[n].hasOwnProperty('original_price')){
            for(let m in pricing_categories[n].category_pricing){
              if(item.group_size >= pricing_categories[n].category_pricing[m].min_players
                && item.group_size <= pricing_categories[n].category_pricing[m].max_players){
                pricing_categories[n].original_price = pricing_categories[n].category_pricing[m].price
              }
            }

            let last_index = _.findLastKey(pricing_categories[n].category_pricing)
            if(last_index && item.group_size > pricing_categories[n].category_pricing[last_index].max_players){
              pricing_categories[n].original_price = pricing_categories[n].category_pricing[last_index].price
            }
            let smallest_price_category = _.find(pricing_categories[n].category_pricing)
            if(smallest_price_category && item.group_size !== 0 &&
              item.group_size < smallest_price_category.min_players){
              pricing_categories[n].original_price = smallest_price_category.price
            }
          }
        }
        else {

          for(let m in pricing_categories[n].category_pricing){
            if(pricing_categories[n].number_of_players >= pricing_categories[n].category_pricing[m].min_players
              && pricing_categories[n].number_of_players <= pricing_categories[n].category_pricing[m].max_players) {
              pricing_categories[n].original_price = pricing_categories[n].category_pricing[m].price
              pricing_categories[n].price = pricing_categories[n].category_pricing[m].price
            }
          }
          let last_index = _.findLastKey(pricing_categories[n].category_pricing)
          if(last_index && pricing_categories[n].number_of_players > pricing_categories[n].category_pricing[last_index].max_players){
            pricing_categories[n].original_price = pricing_categories[n].category_pricing[last_index].price
            pricing_categories[n].price = pricing_categories[n].category_pricing[last_index].price
          }

          let smallest_price_category = _.find(pricing_categories[n].category_pricing)
          if(smallest_price_category && pricing_categories[n].number_of_players !== 0 &&
            pricing_categories[n].number_of_players < smallest_price_category.min_players){
            pricing_categories[n].original_price = smallest_price_category.price
            pricing_categories[n].price = smallest_price_category.price
          }
        }
      }
      this.$set(this.price_override, index, true);
    },
    saveOverride(pricing_categories, index, item){
      for(let n in pricing_categories){
        if(pricing_categories[n].hasOwnProperty('original_price') &&
          pricing_categories[n].original_price  === pricing_categories[n].price){
          delete pricing_categories[n].original_price
        }
      }
      this.getBookingSubtotal(item)
      if(this.waive_tax){
        this.waiveTaxes()
      } else {
        this.getSubTotal()
        this.getTaxes()
        this.getFees()
        this.getTotal()
      }
      this.$set(this.price_override, index, false);
    },
    setOriginalPrice(category){
      category.price = category.original_price
    },
    async giftCardSearch(queryString, cb){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/gifts/autocomplete?q=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.gift_cards){
            if(response.data.gift_cards[n].code != null){
              suggestions.push({
                value: JSON.stringify(response.data.gift_cards[n]),
                id: response.data.gift_cards[n].id,
                code: response.data.gift_cards[n].code,
                customer_id: response.data.gift_cards[n].customer_id,
                date_purchased: response.data.gift_cards[n].date_purchased,
                email: response.data.gift_cards[n].email,
                first_name: response.data.gift_cards[n].first_name,
                last_name: response.data.gift_cards[n].last_name,
                remaining: response.data.gift_cards[n].remaining,
                total: response.data.gift_cards[n].total
              })
            }

          }
          const results = suggestions

          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    handleGiftCardSelect(item){
      this.gift_card_code = this.getGiftCardCode(item.code)
      this.selectedGiftCardCode = item
    },
    getGiftCardCode(code){
      if(!code){
        return
      }
      if(isNaN(code)){
        return code
      }
      let c = code.match(/.{1,4}/g);
      return c.join(' ')
    },
    recalculateDiscount(){
      for(let n in this.promos){
        this.removePromoCode(this.promos[n])
      }
    },
    getBookingSubtotal(game){
      let pricing = slotPricingRows(game, game.selected_duration_id)

      game.total = 0
      game.group_size = 0
      if(game.cumulative_category_pricing){
        if(game.pricing_type_id === 1){
          for (let m in game.tickets) {
            game.group_size += game.tickets[m].number_of_players
          }
          for(let m in game.tickets){
            for(let n in pricing){
              if(pricing[n].category_id === game.tickets[m].category_id
                && game.group_size >= pricing[n].min_players
                && game.group_size <= pricing[n].max_players) {
                if(game.tickets[m].hasOwnProperty('original_price')){
                  game.total += game.tickets[m].price * game.tickets[m].number_of_players
                } else {
                  game.total += pricing[n].price * game.tickets[m].number_of_players
                }
                break
              }
            }
            let last_index = _.findLastKey(pricing, {category_id: game.tickets[m].category_id})
            if(game.group_size > pricing[last_index].max_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += game.tickets[m].price * game.tickets[m].number_of_players
              } else {
                game.total += pricing[last_index].price * game.tickets[m].number_of_players
              }

            }

            let smallest_price_category = _.find(pricing, {category_id : game.tickets[m].category_id})
            if(game.group_size !== 0 &&
              game.group_size < smallest_price_category.min_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += game.tickets[m].price * game.tickets[m].number_of_players
              } else {
                game.total += smallest_price_category.price * game.tickets[m].number_of_players
              }

            }
          }
        }
        else if(game.pricing_type_id === 2){
          for (let m in game.tickets) {
            game.group_size += game.tickets[m].number_of_players
          }
          for(let m in game.tickets){
            // Empty categories are never sold; total headcount only picks the tier (OTC-2911)
            if(!(game.tickets[m].number_of_players > 0)) continue
            for(let n in pricing){
              if(pricing[n].category_id === game.tickets[m].category_id
                && game.group_size >= pricing[n].min_players
                && game.group_size <= pricing[n].max_players) {
                if(game.tickets[m].hasOwnProperty('original_price')){
                  game.total += Number(game.tickets[m].price)
                } else {
                  game.total += Number(pricing[n].price)
                }

                break
              }
            }
            let last_index = _.findLastKey(pricing, {category_id: game.tickets[m].category_id})
            if(game.group_size > pricing[last_index].max_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += Number(game.tickets[m].price)
              } else {
                game.total += Number(pricing[last_index].price)
              }
            }

            let smallest_price_category = _.find(pricing, {category_id : game.tickets[m].category_id})
            if(game.group_size !== 0 &&
              game.group_size < smallest_price_category.min_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += Number(game.tickets[m].price)
              } else {
                game.total += Number(smallest_price_category.price)
              }

            }
          }
        }
      } else {
        if(game.pricing_type_id === 1){
          for(let m in game.tickets){

            game.group_size += game.tickets[m].number_of_players
            for(let n in pricing){
              if(pricing[n].category_id === game.tickets[m].category_id
                && game.tickets[m].number_of_players >= pricing[n].min_players
                && game.tickets[m].number_of_players <= pricing[n].max_players) {
                if(game.tickets[m].hasOwnProperty('original_price')){
                  game.total += game.tickets[m].price * game.tickets[m].number_of_players
                } else {
                  game.total += pricing[n].price * game.tickets[m].number_of_players
                }

                break
              }
            }
            let last_index = _.findLastKey(pricing, {category_id: game.tickets[m].category_id})
            if(game.tickets[m].number_of_players > pricing[last_index].max_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += game.tickets[m].price * game.tickets[m].number_of_players
              } else {
                game.total += pricing[last_index].price * game.tickets[m].number_of_players
              }

            }

            let smallest_price_category = _.find(pricing, {category_id : game.tickets[m].category_id})
            if(game.tickets[m].number_of_players !== 0 &&
              game.tickets[m].number_of_players < smallest_price_category.min_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += game.tickets[m].price * game.tickets[m].number_of_players
              } else {
                game.total += smallest_price_category.price * game.tickets[m].number_of_players
              }

            }
          }
        }
        else if(game.pricing_type_id === 2){
          for(let m in game.tickets){
            game.group_size += game.tickets[m].number_of_players
            for(let n in pricing){
              if(pricing[n].category_id === game.tickets[m].category_id
                && game.tickets[m].number_of_players >= pricing[n].min_players
                && game.tickets[m].number_of_players <= pricing[n].max_players) {
                if(game.tickets[m].hasOwnProperty('original_price')){
                  game.total += Number(game.tickets[m].price)
                } else {
                  game.total += Number(pricing[n].price)
                }

                break
              }
            }
            let last_index = _.findLastKey(pricing, {category_id: game.tickets[m].category_id})
            if(game.tickets[m].number_of_players > pricing[last_index].max_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += Number(game.tickets[m].price)
              } else {
                game.total += Number(pricing[last_index].price)
              }

            }

            let smallest_price_category = _.find(pricing, {category_id : game.tickets[m].category_id})
            if(game.tickets[m].number_of_players !== 0 &&
              game.tickets[m].number_of_players < smallest_price_category.min_players){
              if(game.tickets[m].hasOwnProperty('original_price')){
                game.total += Number(game.tickets[m].price)
              } else {
                game.total += Number(smallest_price_category.price)
              }
            }
          }
        }
      }
      game.computed_total = game.total
    },
    onPlayerCountChange(game){
      this.getBookingSubtotal(game)
      if(this.waive_tax){
        this.waiveTaxes()
      } else {
        this.getSubTotal()
        this.getTaxes()
        this.getFees()
        this.getTotal()
      }
    },
    getRate(item, game){
      let pricing = slotPricingRows(game, game.selected_duration_id)
      if(game.cumulative_category_pricing){
        for(let n in pricing){
          if(pricing[n].category_id === item.category_id
            && game.group_size >= pricing[n].min_players
            && game.group_size <= pricing[n].max_players) {
            if(item.hasOwnProperty('original_price')){
              return game.pricing_type_id === 1 ? item.price
                : this.getAmount(item.price) + ' for '  + pricing[n].min_players + '-'
                + pricing[n].max_players + ' ' + item.category
            } else {
              return game.pricing_type_id === 1 ? pricing[n].price
                : this.getAmount(pricing[n].price) + ' for ' + pricing[n].min_players + '-'
                + pricing[n].max_players + ' ' + item.category
            }
          }
        }

        let last_index = _.findLastKey(pricing, {category_id: item.category_id})
        if(game.group_size > pricing[last_index].max_players){
          if(item.hasOwnProperty('original_price')){
            return game.pricing_type_id === 1 ? item.price
              : this.getAmount(item.price) + ' for '
              + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' ' + item.category
          } else {
            return game.pricing_type_id === 1 ? pricing[last_index].price
              : this.getAmount(pricing[last_index].price) + ' for ' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' ' + item.category
          }

        }

        let smallest_price_category = _.find(pricing, {category_id : item.category_id})
        if(game.group_size !== 0 &&
          game.group_size < smallest_price_category.min_players){
          if(item.hasOwnProperty('original_price')){
            return game.pricing_type_id === 1 ? item.price
              : this.getAmount(item.price) + ' for ' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' ' + item.category
          } else {
            return game.pricing_type_id === 1 ?smallest_price_category.price
              : this.getAmount(smallest_price_category.price) + ' for ' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' ' + item.category
          }
        }
      } else {
        for(let n in pricing){
          if(pricing[n].category_id === item.category_id
            && item.number_of_players >= pricing[n].min_players
            && item.number_of_players <= pricing[n].max_players) {
            if(item.hasOwnProperty('original_price')){
              return game.pricing_type_id === 1 ? item.price
                : this.getAmount(item.price) + ' for '  + pricing[n].min_players + '-'
                + pricing[n].max_players + ' ' + item.category
            } else {
              return game.pricing_type_id === 1 ? pricing[n].price
                : this.getAmount(pricing[n].price) + ' for '  + pricing[n].min_players + '-'
                + pricing[n].max_players + ' ' + item.category
            }
          }
        }

        let last_index = _.findLastKey(pricing, {category_id: item.category_id})
        if(item.number_of_players > pricing[last_index].max_players){
          if(item.hasOwnProperty('original_price')){
            return game.pricing_type_id === 1 ? item.price
              : this.getAmount(item.price)
              + ' for ' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' ' + item.category
          } else {
            return game.pricing_type_id === 1 ? pricing[last_index].price
              : this.getAmount(pricing[last_index].price) + ' for ' + pricing[last_index].min_players + '-' + pricing[last_index].max_players + ' ' + item.category
          }

        }

        let smallest_price_category = _.find(pricing, {category_id : item.category_id})
        if(item.number_of_players !== 0 &&
          item.number_of_players < smallest_price_category.min_players){
          if(item.hasOwnProperty('original_price')){
            return game.pricing_type_id === 1 ? item.price
              : this.getAmount(item.price) + ' for ' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' ' + item.category
          } else {
            return game.pricing_type_id === 1 ? smallest_price_category.price
              : this.getAmount(smallest_price_category.price) + ' for ' + smallest_price_category.min_players + '-' + smallest_price_category.max_players + ' ' + item.category
          }
        }
      }

      return 0
    },
    removePromoCode(item){
      _.remove(this.promos, {
        id: item.id
      });
      for(let m in this.cart){
        _.remove(this.cart[m].promos, {
          id: item.id
        });
      }
      // Clear and recalculate promo_discount for all cart items
      this.recalculateCartPromoDiscounts()
      this.pc_key++
    },
    clearCartPromoDiscounts() {
      for (let i = 0; i < this.cart.length; i++) {
        this.cart[i].promo_discount = 0
      }
    },
    recalculateCartPromoDiscounts() {
      // Clear all promo_discount values first
      this.clearCartPromoDiscounts()
      // Recalculate for remaining promos by triggering getDiscount on each
      for (const promo of this.promos) {
        this.getDiscount(promo)
      }
    },
    validatePromoRules(promoCode) {
      // If no rules configured, validation passes
      if (!promoCode.rules || promoCode.rules.length === 0) {
        return { valid: true }
      }

      // Validate each rule (AND logic - all must pass)
      for (const rule of promoCode.rules) {
        const result = this.validatePromoRule(rule, promoCode)
        if (!result.valid) {
          return result
        }
      }

      return { valid: true }
    },
    validatePromoRule(rule, promoCode) {
      const ruleKey = rule.rule_type?.rule_key || rule.rule_key

      switch (ruleKey) {
        case 'MIN_QUANTITY':
          return this.validateMinQuantityRule(rule.rule_config, promoCode)

        case 'BUY_X_GET_Y':
          return this.validateBuyXGetYRule(rule.rule_config, promoCode)

        default:
          console.warn(`Unknown rule type: ${ruleKey}`)
          return { valid: true }
      }
    },
    validateMinQuantityRule(config, promoCode) {
      // For NewTransaction.vue, we have a cart with multiple items
      // Calculate total based on all items in cart that the promo applies to
      let quantity = 0

      // Get game IDs that the promo applies to
      const promoGameIds = promoCode.games ? promoCode.games.map(g => g.id) : []

      switch (config.applies_to) {
        case 'total_participants':
          // Sum group_size across all cart items that match promo games
          for (const cartItem of this.cart) {
            // If promo has no specific games, apply to all
            // Otherwise, only count if cart item game matches promo games
            if (promoGameIds.length === 0 || promoGameIds.includes(cartItem.game_id)) {
              quantity += cartItem.group_size || 0
            }
          }
          break

        case 'line_items':
          // Count number of cart items that match promo games
          for (const cartItem of this.cart) {
            if (promoGameIds.length === 0 || promoGameIds.includes(cartItem.game_id)) {
              quantity += 1
            }
          }
          break

        case 'unique_items':
          // Count unique game IDs in cart that match promo games
          const uniqueGameIds = new Set()
          for (const cartItem of this.cart) {
            if (promoGameIds.length === 0 || promoGameIds.includes(cartItem.game_id)) {
              uniqueGameIds.add(cartItem.game_id)
            }
          }
          quantity = uniqueGameIds.size
          break

        default:
          console.warn(`Unknown applies_to value: ${config.applies_to}`)
          return { valid: true }
      }

      if (quantity < config.min_quantity) {
        const errorMessage = config.error_message ||
          `Minimum quantity of ${config.min_quantity} required (current: ${quantity})`

        return {
          valid: false,
          error_message: errorMessage
        }
      }

      return { valid: true }
    },
    validateBuyXGetYRule(config, promoCode) {
      const { required_items, discounted_items, error_message } = config

      // Step 1: Check if required items (X) are in cart
      const hasRequiredItems = this.checkRequiredItemsInCart(required_items, promoCode)

      if (!hasRequiredItems) {
        return {
          valid: false,
          error_message: error_message || 'Required items not in cart for this promotion'
        }
      }

      // Step 2: Check if discounted items (Y) are in cart
      const hasDiscountedItems = this.checkDiscountedItemsInCart(discounted_items, promoCode)

      // Step 3: Handle auto_apply_behavior based on whether Y items are in cart
      if (!hasDiscountedItems) {
        const behavior = discounted_items.auto_apply_behavior || 'allow_promo'

        switch (behavior) {
          case 'block_promo':
            return {
              valid: false,
              error_message: error_message || 'You must add the discounted items to your cart to use this promo code'
            }

          case 'show_message':
            // Pass validation but could show a message (would need UI support)
            // For now, just allow the promo
            console.info('Promo applied - discounted items not in cart yet')
            return { valid: true }

          case 'allow_promo':
          default:
            // Allow promo, discount will apply when Y items are added
            return { valid: true }
        }
      }

      return { valid: true }
    },
    checkRequiredItemsInCart(requiredConfig, promoCode) {
      const { item_type, item_ids, min_quantity, match_mode } = requiredConfig

      // Get all cart items
      let cartItems = []

      // For now, we only support games in the cart (booking_slots)
      // NewTransaction.vue cart contains game bookings
      if (item_type === 'games' || item_type === 'any') {
        cartItems = this.cart.map(cartItem => ({
          id: cartItem.game_id,
          quantity: cartItem.group_size || 1
        }))
      } else {
        // Items and gift cards are not typically in NewTransaction cart
        // This would need to be extended if cart supports items/gift cards
        return false
      }

      // If no specific items required, just check quantity
      if (!item_ids || item_ids.length === 0) {
        const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0)
        return totalQuantity >= min_quantity
      }

      // Check based on match mode
      if (match_mode === 'any') {
        // At least one item from item_ids must be present with min_quantity
        const matchingItems = cartItems.filter(item => item_ids.includes(item.id))
        const totalMatchingQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0)
        return totalMatchingQuantity >= min_quantity
      } else {
        // match_mode === 'all'
        // All items from item_ids must be present
        const uniqueMatchingIds = new Set(
          cartItems.filter(item => item_ids.includes(item.id)).map(item => item.id)
        )
        const hasAllItems = uniqueMatchingIds.size === item_ids.length
        const totalMatchingQuantity = cartItems
          .filter(item => item_ids.includes(item.id))
          .reduce((sum, item) => sum + item.quantity, 0)
        return hasAllItems && totalMatchingQuantity >= min_quantity
      }
    },
    checkDiscountedItemsInCart(discountedConfig, promoCode) {
      const { item_type, item_ids } = discountedConfig

      // Get all cart items based on type
      let cartItems = []

      if (item_type === 'games') {
        cartItems = this.cart.map(cartItem => cartItem.game_id)
      } else {
        // Items and gift cards not typically in NewTransaction cart
        return false
      }

      // Check if any discounted items are in cart
      if (!item_ids || item_ids.length === 0) {
        return false // Must specify which items get discounted
      }

      // Check if at least one discounted item is in cart
      return item_ids.some(itemId => cartItems.includes(itemId))
    },
    applyPromoCode(){
      if(this.selectedPromoCode.hasOwnProperty('id')){

        let dupe = 0
        for(let n in this.promos){
          if(this.selectedPromoCode.id === this.promos[n].id){
            dupe++
          }
          if(this.promos[n].is_combineable === 0 || this.selectedPromoCode.is_combineable === 0){
            swal('Error', 'You cannot apply multiple non-combineable promo codes', 'error')
            return
          }
        }

        // Validate promo code rules before applying (skip for gift cards)
        if (!this.selectedPromoCode.hasOwnProperty('code')) {
          const validationResult = this.validatePromoRules(this.selectedPromoCode)
          if (!validationResult.valid) {
            swal('Promo code requirements not met', validationResult.error_message, 'error')
            return
          }
        }

        //Validations
        let game_allowed = false
        let event_date_allowed = false
        let event_time_allowed = false
        let day_allowed = false
        let is_exclusion = false
        let allowed_for_booking = 0

        for(let n in this.cart){
          allowed_for_booking = 0
          //1. If games are allowed
          if (this.selectedPromoCode.is_cross_group) {
            // Cross-group promos apply to all games
            game_allowed = true
          } else if(this.selectedPromoCode.games){
            for(let m in this.selectedPromoCode.games){
              if(this.cart[n].game_id === this.selectedPromoCode.games[m].id){
                game_allowed = true
                allowed_for_booking = 0
                break
              } else {
                allowed_for_booking++
              }
            }
          }
          //2. If event date is allowed
          let booking_date = new Date()
          booking_date.setFullYear(this.cart[n].booking_date.split('T')[0].split('-')[0])
          booking_date.setMonth(this.cart[n].booking_date.split('T')[0].split('-')[1] -1, this.cart[n].booking_date.split('T')[0].split('-')[2])
          if(this.selectedPromoCode.event_is_date_range){
            let start = new Date()
            start.setFullYear(this.selectedPromoCode.event_start_date.split('T')[0].split('-')[0])
            start.setMonth(this.selectedPromoCode.event_start_date.split('T')[0].split('-')[1] -1, this.selectedPromoCode.event_start_date.split('T')[0].split('-')[2])
            let end = new Date()
            end.setFullYear(this.selectedPromoCode.event_end_date.split('T')[0].split('-')[0])
            end.setMonth(this.selectedPromoCode.event_end_date.split('T')[0].split('-')[1] -1, this.selectedPromoCode.event_end_date.split('T')[0].split('-')[2])
            if(booking_date >= start && booking_date <= end){
              event_date_allowed = true
            } else {
              allowed_for_booking++
            }
          } else {
            event_date_allowed = true
          }


          //3. If event time is allowed
          if(this.selectedPromoCode.event_is_time_range){
            let booking_time = new Date()
            booking_time.setHours(this.cart[n].start_time.split(':')[0])
            booking_time.setMinutes(this.cart[n].start_time.split(':')[1])
            let start = new Date()
            start.setHours(this.selectedPromoCode.event_start_time.split(':')[0])
            start.setMinutes(this.selectedPromoCode.event_start_time.split(':')[1])
            let end = new Date()
            end.setHours(this.selectedPromoCode.event_end_time.split(':')[0])
            end.setMinutes(this.selectedPromoCode.event_end_time.split(':')[1])

            if(booking_time >= start && booking_time <= end){
              event_time_allowed = true
            } else {
              allowed_for_booking++
            }
          } else {
            event_time_allowed = true
          }


          //4. If day of week is allowed
          let day_of_week = booking_date.getDay()
          if(this.selectedPromoCode.available_days[day_of_week] == true){
            day_allowed = true
          } else {
            allowed_for_booking++
          }


          //5.If there are exclusion dates for event
          if(this.selectedPromoCode.event_exlusions){
            let bd = this.cart[n].booking_date.split('T')[0]
            let exc = this.selectedPromoCode.event_exlusions.split(',')
            for(let e in exc){
              if(exc[e] === bd){
                is_exclusion = true
                allowed_for_booking++
              }
            }
          }


          if(!game_allowed || !event_date_allowed || !event_time_allowed || !day_allowed || is_exclusion){
            swal('Error', 'The promo code cannot be applied to bookings in your cart', 'error')
            return
          }

          if(dupe !== 0){
            swal('Error', 'You cannot apply the same promo code more than once', 'error')
            return
          }
          //Update booking with added promo code
          if(allowed_for_booking === 0){
            this.cart[n].promos.push(this.selectedPromoCode)
          }
        }
        if(this.selectedPromoCode.value_amount > this.total && this.selectedPromoCode.redemption_type === 1){
          //get the value of taxes that are applied after discount
          let apply_after_discount_taxes = 0
          let waived_taxes = 0
          let waived_fees = 0
          for(let n in this.taxes){
            if(this.taxes[n].apply_after_discount === 1 && !this.waive_tax){
              apply_after_discount_taxes += parseFloat(this.getTax(this.taxes[n]))
            } else if (this.waive_tax){
              waived_taxes += parseFloat(this.getTax(this.taxes[n]))
            }
          }
          if(this.waive_fee){
            for(let n in this.fees){
              waived_fees += parseFloat(this.getFee(this.fees[n]))
            }
          }
          this.selectedPromoCode.value_amount = this.total - apply_after_discount_taxes - waived_taxes - waived_fees
        }

        this.promos.push(this.selectedPromoCode)
        // Clear and recalculate all promo discounts (for accurate per-item tracking)
        this.recalculateCartPromoDiscounts()
        // Recalculate taxes with the new discount
        this.getTaxes()
      }
      this.promo_code = ''
    },
    handlePromoSelect(item){
      this.promo_code = item.name
      this.selectedPromoCode = item
    },
    hasBuyXGetYRule(rules) {
      if (!rules || rules.length === 0) return false;
      return rules.some(r => r.rule_type?.rule_key === 'BUY_X_GET_Y');
    },
    setPartialAmount(){
      this.partial_amount = this.total.toFixed(2)
    },
    getFees(){
      let total_fee = 0
      for(let n in this.fees){
        total_fee += this.getFee(this.fees[n])
      }
      total_fee = roundCents(parseFloat(total_fee))
      this.total_fee = total_fee
      return total_fee
    },
    splitAmount(amount, count) {
      const total = Math.round(Number(amount + 'e2')); // convert to cents using exponential notation
      const base = Math.floor(total / count); // base amount in cents per item
      const remainder = total % count; // how many items need to get an extra cent

      const result = Array(count).fill(base).map((value, index) => {
        // Distribute the remainder by adding 1 cent to the first `remainder` items
        return (value + (index < remainder ? 1 : 0)) / 100;
      });

      return result;
    },
    getTaxes(){
      if(parseFloat(this.subtotal) == 0){
        this.total_tax = 0
        return 0
      }
      // Reset per-item tax before recalculating to prevent stale accumulation
      for(let n in this.cart){
        this.cart[n].tax = 0
      }
      let total_tax = 0
      let accumulated_inclusive_tax = 0
      for(let t in this.taxes){
        // Re-initialize subtotalAmount per tax to prevent cross-tax variable pollution
        let subtotalAmount = 0
        for(let n in this.cart){
          subtotalAmount += this.cart[n].total
        }
        //exclusive of price
        if(this.taxes[t].pricing_type === 0){
          //value (total)
          if(this.taxes[t].value_type === 0){
            total_tax += this.taxes[t].amount
          }
          //value (per person)
          if(this.taxes[t].value_type === 1){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                total_tax += (this.taxes[t].amount * this.cart[n].group_size)
              }
            }
          }
          //percentage
          if(this.taxes[t].value_type === 2){
            // let subtotalAmount = this.subtotal
            if(this.taxes[t].apply_after_discount){
              subtotalAmount = roundCents(subtotalAmount - this.getDiscounts())
            }
            if(this.taxes[t].is_compound){
              let compound_tax = this.getCompoundTax(this.taxes[t])
              subtotalAmount = subtotalAmount + compound_tax
            }
            if(subtotalAmount < 0){
              subtotalAmount = 0
            }
            total_tax += this.getPercentage(this.taxes[t].amount, subtotalAmount)

          }

          if(this.taxes[t].value_type === 3){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                total_tax += this.taxes[t].amount
              }
            }
          }
          if(this.taxes[t].value_type === 4){
            // Calculate total cart price for proportional discount distribution
            let totalCartPrice = this.cart.reduce((sum, item) => sum + item.total, 0)
            let totalDiscount = this.getDiscounts()
            let tax_for_this_type = 0

            for(let n in this.cart){
              subtotalAmount = this.cart[n].total
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                // let subtotalAmount = this.subtotal
                if(this.taxes[t].apply_after_discount){
                  // Calculate proportional discount for this item
                  let itemDiscount = totalCartPrice > 0
                    ? (this.cart[n].total / totalCartPrice) * totalDiscount
                    : 0
                  subtotalAmount = subtotalAmount - itemDiscount
                }
                if(this.taxes[t].is_compound){
                  let compound_tax = this.getCompoundTax(this.taxes[t])
                  subtotalAmount = subtotalAmount + compound_tax
                }
                if(subtotalAmount < 0){
                  subtotalAmount = 0
                }

                if(this.taxes[t].pricing_type === 1){
                  const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor(game_id) * 0.01)))
                  tax_for_this_type += roundCents(baseAmount * (this.taxes[t].amount * 0.01))
                } else {
                  tax_for_this_type += this.getPercentage(this.taxes[t].amount, subtotalAmount)
                }
              }
            }
            // Store computed amount so getTotal() can read it
            this.taxes[t].computed_amount = roundCents(parseFloat(tax_for_this_type))
            total_tax += this.taxes[t].computed_amount
          }
          this.total_tax = roundCents(parseFloat(total_tax))

        }
        else if(this.taxes[t].pricing_type === 1){
          let inclusive_total_tax = 0
          //value (total)
          if(this.taxes[t].value_type === 0){
            inclusive_total_tax += this.taxes[t].amount
            let amounts = this.splitAmount(this.getPercentage(this.taxes[t].amount, subtotalAmount), this.cart.length)
            for(let n in this.cart){
              this.cart[n].tax += amounts[n]
            }
          }
          //value (per person)
          if(this.taxes[t].value_type === 1){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                inclusive_total_tax += (this.taxes[t].amount * this.cart[n].group_size)
                this.cart[n].tax += (this.taxes[t].amount * this.cart[n].group_size)
              }
            }
          }
          if(this.taxes[t].value_type === 2){
            // Inclusive: extract base first, then apply discount to base
            let baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor() * 0.01)))
            if(this.taxes[t].apply_after_discount){
              baseAmount = roundCents(baseAmount - this.getDiscounts())
            }
            if(this.taxes[t].is_compound){
              let compound_tax = this.getCompoundTax(this.taxes[t])
              baseAmount = baseAmount + compound_tax
            }
            if(baseAmount < 0) baseAmount = 0
            let taxAmount = roundCents(baseAmount * (this.taxes[t].amount * 0.01))
            this.taxes[t].computed_amount = taxAmount
            inclusive_total_tax += taxAmount
            if(taxAmount > 0){
              let amounts = this.splitAmount(taxAmount, this.cart.length)
              for(let n in this.cart){
                this.cart[n].tax += amounts[n]
              }
            }
          }
          if(this.taxes[t].value_type === 3){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                inclusive_total_tax += this.taxes[t].amount
                this.cart[n].tax += this.taxes[t].amount
              }
            }
          }

          if(this.taxes[t].value_type === 4){
            // Calculate total cart price for proportional discount distribution
            let totalCartPrice = this.cart.reduce((sum, item) => sum + item.total, 0)
            let totalDiscount = this.getDiscounts()

            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                // Inclusive: extract base first, then apply discount to base
                let baseAmount = roundCents(this.cart[n].total / (1 + (this.inclusiveRateFor(game_id) * 0.01)))
                if(this.taxes[t].apply_after_discount){
                  let itemDiscount = totalCartPrice > 0
                    ? (this.cart[n].total / totalCartPrice) * totalDiscount
                    : 0
                  baseAmount = baseAmount - itemDiscount
                }
                if(this.taxes[t].is_compound){
                  let compound_tax = this.getCompoundTax(this.taxes[t])
                  baseAmount = baseAmount + compound_tax
                }
                if(baseAmount < 0) baseAmount = 0
                let itemTax = roundCents(baseAmount * (this.taxes[t].amount * 0.01))
                inclusive_total_tax += itemTax
                this.cart[n].tax += itemTax
              }
            }
          }
          accumulated_inclusive_tax += inclusive_total_tax
          this.total_tax = roundCents(parseFloat(accumulated_inclusive_tax))
        }
      }
      return roundCents(parseFloat(total_tax))
    },
    getFee(f){
      let total_fee = 0
      if(f.value_type === 0){
        total_fee = f.amount
      }
      if(f.value_type === 1){
        for(let n in this.cart){
          let game_id = this.cart[n].game_id
          let linked_games = JSON.parse(f.linked_games)
          let found = _.find(linked_games, {id: game_id})
          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            total_fee += (f.amount * this.cart[n].group_size)
          }
        }
      }

      //percentage
      if(f.value_type === 2){
        let subtotalAmount = this.subtotal
        if(f.covered_by_promo_codes){
          subtotalAmount = roundCents(subtotalAmount - this.getDiscounts())
        }
        if(subtotalAmount < 0){
          subtotalAmount = 0
        }
        total_fee = this.getPercentage(f.amount, subtotalAmount)
      }

      if(f.value_type === 3){
        for(let n in this.cart){
          let game_id = this.cart[n].game_id
          let linked_games = JSON.parse(f.linked_games)
          let found = _.find(linked_games, {id: game_id})
          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            total_fee += f.amount
          }
        }
      }
      if(f.value_type === 4){
        // Calculate total cart price for proportional discount distribution (used for non-item-specific promos)
        let totalCartPrice = this.cart.reduce((sum, item) => {
          return sum + (this.hasInclusiveTaxes ? item.computed_total : item.total)
        }, 0)
        let totalDiscount = this.getDiscounts()
        // Check if any cart item has item-specific promo_discount (from BUY_X_GET_Y)
        let hasItemSpecificDiscounts = this.cart.some(item => item.promo_discount > 0)

        for(let n in this.cart){
          let game_id = this.cart[n].game_id
          let linked_games = JSON.parse(f.linked_games)
          let found = _.find(linked_games, {id: game_id})
          if((!f.apply_to_all_items && found) || f.apply_to_all_items){
            let subtotalAmount = this.hasInclusiveTaxes ? this.cart[n].computed_total : this.cart[n].total
            if(f.covered_by_promo_codes){
              if (hasItemSpecificDiscounts) {
                // Use item-specific discount (from BUY_X_GET_Y promos)
                let itemDiscount = this.cart[n].promo_discount || 0
                subtotalAmount = subtotalAmount - itemDiscount
              } else {
                // Calculate proportional discount for this item (for regular promos)
                let itemDiscount = totalCartPrice > 0
                  ? (subtotalAmount / totalCartPrice) * totalDiscount
                  : 0
                subtotalAmount = subtotalAmount - itemDiscount
              }
            }
            if(subtotalAmount < 0){
              subtotalAmount = 0
            }
            total_fee += this.getPercentage(f.amount, subtotalAmount)
          }
        }
      }
      return roundCents(parseFloat(total_fee))
    },
    valuesAfterTaxFeeWaiver(){
      // getTotal() already excludes exclusive taxes and fees when waive flags are set,
      // so this method only needs to zero out the values for the submission payload
      let total = this.total
      let total_tax = this.waive_tax ? 0 : this.total_tax
      let total_fee = this.waive_fee ? 0 : this.total_fee

      return {total, total_tax, total_fee}
    },
    getCompoundTax(tax){
      let total_tax = 0
      for(let t in this.taxes){
        if(tax.id === this.taxes[t].id){
          return total_tax
        }
        //exclusive of price
        if(this.taxes[t].pricing_type === 0){
          //value (total)
          if(this.taxes[t].value_type === 0){
            total_tax += this.taxes[t].amount
          }
          //value (per person)
          if(this.taxes[t].value_type === 1){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                total_tax += (this.taxes[t].amount * this.cart[n].group_size)
              }
            }
          }
          //percentage
          if(this.taxes[t].value_type === 2){
            let subtotalAmount = this.subtotal
            if(this.taxes[t].apply_after_discount){
              subtotalAmount = roundCents(subtotalAmount - this.getDiscounts())
            }
            if(this.taxes[t].is_compound){
              let compound_tax = this.getCompoundTax(this.taxes[t])
              subtotalAmount = subtotalAmount + compound_tax
            }
            if(subtotalAmount < 0){
              subtotalAmount = 0
            }
            total_tax += this.getPercentage(this.taxes[t].amount, subtotalAmount)
          }

          if(this.taxes[t].value_type === 3){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                total_tax += this.taxes[t].amount
              }
            }
          }

          if(this.taxes[t].value_type === 4){
            let totalCartPrice = this.cart.reduce((sum, item) => sum + item.total, 0)
            let totalDiscount = this.getDiscounts()
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                let subtotalAmount = this.cart[n].total
                if(this.taxes[t].apply_after_discount){
                  let itemDiscount = totalCartPrice > 0
                    ? (this.cart[n].total / totalCartPrice) * totalDiscount
                    : 0
                  subtotalAmount = subtotalAmount - itemDiscount
                }
                if(this.taxes[t].is_compound){
                  let compound_tax = this.getCompoundTax(this.taxes[t])
                  subtotalAmount = subtotalAmount + compound_tax
                }
                if(subtotalAmount < 0){
                  subtotalAmount = 0
                }

                if(this.taxes[t].pricing_type === 1){
                  const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor(game_id) * 0.01)))
                  total_tax += roundCents(baseAmount * (this.taxes[t].amount * 0.01))
                } else {
                  total_tax += this.getPercentage(this.taxes[t].amount, subtotalAmount)
                }
              }
            }
          }
        }
        else if(this.taxes[t].pricing_type === 1){
          let inclusive_total_tax = 0
          //value (total)
          if(this.taxes[t].value_type === 0){
            inclusive_total_tax += this.taxes[t].amount
          }
          //value (per person)
          if(this.taxes[t].value_type === 1){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                inclusive_total_tax += (this.taxes[t].amount * this.cart[n].group_size)
              }
            }
          }
          if(this.taxes[t].value_type === 2){
            let subtotalAmount = this.subtotal
            if(this.taxes[t].apply_after_discount){
              subtotalAmount = roundCents(subtotalAmount - this.getDiscounts())
            }
            if(this.taxes[t].is_compound){
              let compound_tax = this.getCompoundTax(this.taxes[t])
              subtotalAmount = subtotalAmount + compound_tax
            }
            if(subtotalAmount < 0){
              subtotalAmount = 0
            }

            const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor() * 0.01)))
            inclusive_total_tax = roundCents(baseAmount * (this.taxes[t].amount * 0.01))
          }
          if(this.taxes[t].value_type === 3){
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                inclusive_total_tax += this.taxes[t].amount
              }
            }
          }

          if(this.taxes[t].value_type === 4){
            let totalCartPrice = this.cart.reduce((sum, item) => sum + item.total, 0)
            let totalDiscount = this.getDiscounts()
            for(let n in this.cart){
              let game_id = this.cart[n].game_id
              let linked_games = JSON.parse(this.taxes[t].linked_games)
              let found = _.find(linked_games, {id: game_id})
              if((!this.taxes[t].apply_to_all_items && found) || this.taxes[t].apply_to_all_items){
                let subtotalAmount = this.cart[n].total
                if(this.taxes[t].apply_after_discount){
                  let itemDiscount = totalCartPrice > 0
                    ? (this.cart[n].total / totalCartPrice) * totalDiscount
                    : 0
                  subtotalAmount = subtotalAmount - itemDiscount
                }
                if(this.taxes[t].is_compound){
                  let compound_tax = this.getCompoundTax(this.taxes[t])
                  subtotalAmount = subtotalAmount + compound_tax
                }
                if(subtotalAmount < 0){
                  subtotalAmount = 0
                }

                if(this.taxes[t].pricing_type === 1){
                  const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor(game_id) * 0.01)))
                  inclusive_total_tax += roundCents(baseAmount * (this.taxes[t].amount * 0.01))
                } else {
                  inclusive_total_tax += this.getPercentage(this.taxes[t].amount, subtotalAmount)
                }
              }
            }
          }
        }
      }
      return roundCents(parseFloat(total_tax))
    },
    getTax(t){
      if(parseFloat(this.subtotal) == 0){
        return 0
      }

      let subtotalAmount = 0
      for(let n in this.cart){
        subtotalAmount +=this.cart[n].total
      }
      let total_tax = 0
      if(t.pricing_type === 0 || t.pricing_type === 1){
        //value (total) / transaction
        if(t.value_type === 0){
          total_tax = t.amount
        }
        //value (per person)
        if(t.value_type === 1){
          for(let n in this.cart){
            let game_id = this.cart[n].game_id
            let linked_games = t.linked_games ? JSON.parse(t.linked_games) : []
            let found = _.find(linked_games, {id: game_id})
            if((!t.apply_to_all_items && found) || t.apply_to_all_items){
              total_tax += (t.amount * this.cart[n].group_size)
            }
          }
        }
        //percentage
        if(t.value_type === 2){
          // let subtotalAmount = this.subtotal
          if(t.apply_after_discount){
            subtotalAmount = roundCents(subtotalAmount - this.getDiscounts())
          }
          if(t.is_compound){
            let compound_tax = this.getCompoundTax(t)
            subtotalAmount = subtotalAmount + compound_tax
          }
          if(subtotalAmount < 0){
            subtotalAmount = 0
          }

          if(t.pricing_type === 1){
            const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor() * 0.01)))
            total_tax = roundCents(baseAmount * (t.amount * 0.01))
          } else {
            total_tax = this.getPercentage(t.amount, subtotalAmount)
          }
        }
        if(t.value_type === 3){
          for(let n in this.cart){
            let game_id = this.cart[n].game_id
            let linked_games = t.linked_games ? JSON.parse(t.linked_games) : []
            let found = _.find(linked_games, {id: game_id})
            if((!t.apply_to_all_items && found) || t.apply_to_all_items){
              total_tax += t.amount
            }
          }
        }
        if(t.value_type === 4){
          // Calculate total cart price for proportional discount distribution
          let totalCartPrice = this.cart.reduce((sum, item) => sum + item.total, 0)
          let totalDiscount = this.getDiscounts()

          for(let n in this.cart){
            let game_id = this.cart[n].game_id
            let linked_games = t.linked_games ? JSON.parse(t.linked_games) : []
            let found = _.find(linked_games, {id: game_id})
            if((!t.apply_to_all_items && found) || t.apply_to_all_items){
              let subtotalAmount = this.cart[n].total
              if(t.apply_after_discount){
                // Calculate proportional discount for this item
                let itemDiscount = totalCartPrice > 0
                  ? (this.cart[n].total / totalCartPrice) * totalDiscount
                  : 0
                subtotalAmount = subtotalAmount - itemDiscount
              }
              if(t.is_compound){
                let compound_tax = this.getCompoundTax(t)
                subtotalAmount = subtotalAmount + compound_tax
              }
              if(subtotalAmount < 0){
                subtotalAmount = 0
              }

              if(t.pricing_type === 1){
                const baseAmount = roundCents(subtotalAmount / (1 + (this.inclusiveRateFor(game_id) * 0.01)))
                total_tax += roundCents(baseAmount * (t.amount * 0.01))
              } else {
                total_tax += this.getPercentage(t.amount, subtotalAmount)
              }
            }
          }
        }
      }
      t.computed_amount = total_tax
      return roundCents(parseFloat(total_tax))
    },
    getPercentage(amount, subtotal){
      if(subtotal && subtotal.toString().includes(',')){
        subtotal = subtotal.replace(',', '.')
      }
      if(amount && amount.toString().includes(',')){
        amount = amount.replace(',', '.')
      }
      return Number(Math.round(parseFloat(subtotal) * parseFloat(amount)) + 'e-2')
    },
    getAmount(integer) {
      if (integer == null) {
        return;
      }

      // Get currency info
      const currencyInfo = _.find(this.currencies, { code: this.currency });
      const symbol = currencyInfo ? currencyInfo.symbol : this.currency_symbol;
      const isPostfix = currencyInfo ? currencyInfo.postfix : false;

      let formattedAmount;

      if (this.number_format === 1) {
        // European formatting (comma as decimal separator)
        formattedAmount = integer.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
      } else {
        // Standard formatting (dot as decimal separator)
        formattedAmount = parseFloat(integer).toFixed(2);
      }

      if (this.currency_format === 0) {
        // Symbol format
        if (isPostfix) {
          return formattedAmount + symbol;  // 12.34kr
        } else {
          return symbol + formattedAmount;  // $12.34
        }
      } else {
        // Currency code format
        return formattedAmount + ' ' + this.currency;  // 12.34 SEK
      }
    },
    async initializeCard(payments) {
      const customStyle = {
        '.input-container.is-focus': {
          borderColor: '#e14eca',
        },
        '.input-container.is-error': {
          borderColor: '#ff1600',
        },
        '.message-text.is-error': {
          color: '#ff1600',
        },
        '.message-icon.is-error': {
          color: '#ff1600',
        },
        'input.is-error': {
          color: '#ff1600',
        },
        '.message-icon': {
          color: '#adb5bd',
        },
        '@media screen and (max-width: 600px)': {
          'input': {
            'fontSize': '12px',
          }
        },
        '.input-container': {
          // borderColor: 'inherit',
          // backgroundColor: this.bss.card_color,
          // color: this.bss.text_color_card,
          // 'font-family': this.bss.font_family_card,
          borderRadius: '6px',
        },
        '.message-text': {
          color: '#adb5bd',
          // 'font-family': this.bss.font_family_card
        },
        input: {
          backgroundColor: localStorage.getItem('mode') === '0' ? '#ffffff' : '#22233a',
          color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff',

          // fontFamily: 'helvetica neue, sans-serif',
          //fontFamily: this.bss.font_family_card
        },
        'input::placeholder': {
          color: '#adb5bd',
        },
      }
      const card = await payments.card({
        style: customStyle,
      });
      await card.attach('#card-container');
      return card;
    },
    async verifyBuyer(payments, token, zip) {

      const verificationDetails = {
        amount: this.total.toString(),
        /* collected from the buyer */
        billingContact: {
          familyName: this.user.last_name,
          givenName: this.user.first_name,
          postalCode: zip
        },
        currencyCode: this.currency,
        intent: 'CHARGE',
      };

      const verificationResults = await payments.verifyBuyer(
        token,
        verificationDetails
      );
      return verificationResults.token;
    },
    async handlePaystackPayment(type, reference){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId +  '/groups/' + companyGroupId +'/transactions'

      let data = {
        amount: this.getTotal(),
        subtotal: this.subtotal,
        tax: this.valuesAfterTaxFeeWaiver().total_tax,
        discount: this.getDiscounts(),
        no_confirmation_email: this.no_confirmation_email,
        send_payment_request: this.send_payment_request,
        promo_codes: this.promos,
        fee: this.valuesAfterTaxFeeWaiver().total_fee,
        waive_taxes: this.waive_tax ? 1 : 0,
        waive_fees: this.waive_fee ? 1 : 0,
        total: this.valuesAfterTaxFeeWaiver().total,
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        bookings: this.cart,
        custom_field_responses: this.customFieldResponsesPayload(),
        token: token.id,
        paystack_reference: reference,
        payment: {cardNumber: '1111'},
      }

      if(this.pay_partial_amount){
        if(parseFloat(this.partial_amount) > parseFloat(this.total)){
          this.errs.partial_amount = 'Amount cannot be greater than total'
          this.pa_key++
          this.loading = false
          return
        } else {
          this.errs.partial_amount = ''
          this.pa_key++
        }
        data.partial_amount = this.partial_amount
      }
      data.user.phone = data.user.phone === null ? '' : data.user.phone
      this.axios.put(url, data, config)
        .then(response => {
          this.loading = false
          swal('Success!', 'The transaction was created', 'success')
          localStorage.removeItem('cart')
          localStorage.removeItem('taxes')
          localStorage.removeItem('customer')
          this.addAnotherBooking()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status == 500) {
            swal({
              title: 'Error!',
              text: err.response.data,
              type: 'error',
            })
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async payWithPaystack() {
      // Metadata lets the paystack-webhook orphan-log this charge with full
      // recovery context if the callback below never reaches the lambda (the
      // cart exists only in this browser). A session hiccup must never block
      // a charge, so the operator email is best-effort.
      let operatorEmail = null
      try {
        const session = await Auth.currentSession()
        operatorEmail = session.getIdToken().payload.email
      } catch (e) {
        operatorEmail = null
      }
      const popup = new PaystackPop()
      popup.newTransaction({
        key: this.payment_settings.api_name,
        email: this.user.email,
        amount: Math.round(Number(parseFloat(this.getTotal()) + 'e2')),
        reference: ''+Math.floor((Math.random() * 1000000000) + 1),
        metadata: {
          otc: 1,
          otc_flow: 'console_new_transaction',
          otc_company_group_id: JSON.parse(localStorage.getItem('group') || '{}').id,
          otc_company_id: localStorage.getItem('companyId'),
          ...(operatorEmail ? { otc_user_email: operatorEmail } : {})
        },
        onSuccess: (response) => {
          // The lambda reads paystack_reference.transaction (v1 field name);
          // v2 carries the numeric transaction id as response.trans (verified from a live callback).
          this.handlePaystackPayment('new', { ...response, transaction: response.trans })
        }
      });
    },
    async loadPaystack(){
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v2/inline.js'
      script.async = true;
      document.body.appendChild(script);
    },
    async loadStripe(){
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      document.body.appendChild(script);
    },
    async loadSquare(is_live){
      const script = document.createElement('script');
      if(is_live){
        script.src = 'https://web.squarecdn.com/v1/square.js'
      } else {
        script.src = 'https://sandbox.web.squarecdn.com/v1/square.js'
      }
      script.async = true;
      document.body.appendChild(script);
    },
    async initializeSquare(type){
      if (!window.Square) {
        throw new Error('Square.js failed to load properly');
      }

      // Check if container exists
      const containerId = type === 'add_payment' ? '#add-payment-card-container' : '#card-container'
      const container = document.querySelector(containerId)
      if (!container) {
        console.log('Square card container not found, skipping initialization')
        return
      }

      // If the container already has a child, Square already attached. Don't rely on
      // this.card being truthy — it's null during the await window inside initializeCard,
      // so a re-entrant initializeSquare() during that window would double-attach.
      if (container.children.length > 0) {
        return
      }

      // Destroy existing card if present
      if (this.card) {
        try {
          await this.card.destroy()
        } catch (e) {
          console.log('Error destroying existing Square card:', e)
        }
        this.card = null
      }

      this.square = window.Square.payments(this.squareAppId, this.squareLocationId);
      try {
        if(type == 'add_payment'){
          this.card = await this.initializeCardAddPayment(this.square);
        } else {
          this.card = await this.initializeCard(this.square);
        }

      } catch (e) {
        console.error('Initializing Card failed', e);
        return;
      }
    },
    async initializeStripe(){
      // Wait for DOM to be ready
      await this.$nextTick()

      const cardElement = document.getElementById('card-element')
      if (!cardElement) {
        console.warn('Stripe card element not found, will retry when payment form is shown')
        return
      }

      // If the element already has a child, Stripe already mounted. Same reasoning as
      // initializeSquare: don't gate on this.card, which is null during the create() await.
      if (cardElement.children.length > 0) {
        return
      }

      // A Stripe Connect venue tokenizes inside its connected account (platform key + account).
      const accountOpts = this.payment_settings.stripe_account_id ? { stripeAccount: this.payment_settings.stripe_account_id } : undefined;
      this.stripe = window.Stripe(this.payment_settings.api_name, accountOpts);
      this.elements = await this.stripe.elements();
      const style = {
        base: {
          fontSize: '16px',
          fontFamily: 'Poppins, sans-serif',
          color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff'
        },
      };
      // Create an instance of the card Element.
      this.card = await this.elements.create('card', {style});
      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount('#card-element');
      this.card.on('change', (event) => {
        this.card_complete = !!event.complete
        this.card_error_message = event.error ? event.error.message : ''
      })
    },
    async getStripeCustomer(endUserId) {
      if (!endUserId || this.payment_settings.payment_gateway_id !== 3) {
        return
      }
      try {
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + endUserId + '/stripe-customer'

        const response = await axios.get(url, config)
        if (response.data.stripe_customer) {
          this.stripe_customer = response.data.stripe_customer
          this.stripe_payment_methods = response.data.payment_methods || []

          // Auto-select default card or first card
          if (this.stripe_payment_methods.length > 0) {
            const defaultCard = this.stripe_payment_methods.find(pm => pm.is_default)
            this.selected_payment_method = defaultCard ? defaultCard.id : this.stripe_payment_methods[0].id
            this.selectedStoredCard = defaultCard || this.stripe_payment_methods[0]
          } else {
            this.selected_payment_method = 'new'
            this.selectedStoredCard = null
          }
        }
      } catch (err) {
        console.log('No Stripe customer found or error fetching:', err)
        this.stripe_customer = null
        this.stripe_payment_methods = []
        this.selected_payment_method = 'new'
        this.selectedStoredCard = null
      }
    },
    resetStripePaymentMethods() {
      this.selected_payment_method = 'new'
      this.selectedStoredCard = null
      this.save_card_for_future = false
      this.stripe_customer = null
      this.stripe_payment_methods = []
    },
    async loadSquarePaymentMethods(endUserId) {
      if (!endUserId) {
        this.square_payment_methods = []
        this.square_customer = null
        return
      }

      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${endUserId}/square-customer`

        const response = await axios.get(url, config)
        this.square_customer = response.data.square_customer
        this.square_payment_methods = response.data.payment_methods || []

        if (this.square_payment_methods.length > 0) {
          const defaultCard = this.square_payment_methods.find(pm => pm.is_default)
          this.selected_payment_method = defaultCard ? defaultCard.id : this.square_payment_methods[0].id
          this.selectedSquareStoredCard = defaultCard || this.square_payment_methods[0]
        } else {
          this.selected_payment_method = 'new'
          // Reinitialize Square form when no stored cards found
          await this.reinitializeSquareForm()
        }
      } catch (error) {
        // 404 is expected if customer doesn't have a Square account yet
        if (error.response && error.response.status !== 404) {
          console.error('Error loading Square payment methods:', error)
        }
        this.selected_payment_method = 'new'
        this.square_payment_methods = []
        this.square_customer = null
        // Reinitialize Square form on error
        await this.reinitializeSquareForm()
      }
    },
    resetSquarePaymentMethods() {
      this.selected_payment_method = 'new'
      this.selectedSquareStoredCard = null
      this.save_card_for_future = false
      this.square_customer = null
      this.square_payment_methods = []
    },
    async reinitializeSquareForm() {
      // Only reinitialize if using Square payment gateway
      if (this.payment_settings.payment_gateway_id === 2) {
        // Destroy existing card element first
        if (this.card) {
          try {
            await this.card.destroy()
          } catch (e) {
            console.log('Error destroying Square card:', e)
          }
          this.card = null
        }
        // Clear the container to ensure fresh initialization
        const container = document.querySelector('#card-container')
        if (container) {
          container.innerHTML = ''
        }
        // Reinitialize Square form after DOM updates
        await this.$nextTick()
        await this.initializeSquare()
      }
    },
    async onSquarePaymentMethodChange() {
      if (this.selected_payment_method === 'new') {
        this.selectedSquareStoredCard = null
        // Reinitialize Square form when switching to new card
        await this.reinitializeSquareForm()
      } else {
        this.selectedSquareStoredCard = this.square_payment_methods.find(pm => pm.id === this.selected_payment_method)
      }
      this.save_card_for_future = false
    },
    getCardBrandIcon(brand) {
      const icons = {
        'visa': 'fab fa-cc-visa',
        'mastercard': 'fab fa-cc-mastercard',
        'amex': 'fab fa-cc-amex',
        'discover': 'fab fa-cc-discover',
        'diners': 'fab fa-cc-diners-club',
        'jcb': 'fab fa-cc-jcb'
      }
      return icons[brand?.toLowerCase()] || 'far fa-credit-card'
    },
    getCardBrandName(brand) {
      const names = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'amex': 'American Express',
        'discover': 'Discover',
        'diners': 'Diners Club',
        'jcb': 'JCB'
      }
      return names[brand?.toLowerCase()] || brand || 'Card'
    },
    onPaymentMethodChange() {
      if (this.selected_payment_method === 'new') {
        this.selectedStoredCard = null
        // Force fresh Stripe Elements mount when switching to new card
        if (this.card) {
          this.card.unmount()
          this.card = null
        }
        this.$nextTick(() => {
          this.initializeStripe()
        })
      } else {
        this.selectedStoredCard = this.stripe_payment_methods.find(pm => pm.id === this.selected_payment_method)
      }
      this.save_card_for_future = false
    },
    showStoreCreditCardOption() {
      return this.payment_settings.payment_gateway_id === 3 &&
        this.payment_settings.store_credit_card &&
        this.payment_settings.create_customer &&
        (this.user.end_user_id || this.user.email) &&
        this.selected_payment_method === 'new'
    },
    showSquareStoreCreditCardOption() {
      return this.payment_settings.payment_gateway_id === 2 &&
        this.payment_settings.square_store_credit_card &&
        this.payment_settings.square_create_customer &&
        (this.user.end_user_id || this.user.email) &&
        this.selected_payment_method === 'new'
    },
    async handleStripePayment(){
      const isStoredCard = this.selected_payment_method !== 'new' && this.selectedStoredCard

      let tokenId = null
      if (!isStoredCard) {
        let tokenResult
        try {
          tokenResult = await this.stripe.createToken(this.card)
        } catch (e) {
          // Stripe can reject with IntegrationError when the Element was torn down
          // (e.g. tab switch destroyed #card-element). Don't let it strand the spinner.
          console.error('Stripe createToken threw', e)
          swal('Error!', 'There was an issue with your payment. Re-enter card details on the Payment tab.', 'error')
          this.loading = false
          if(this.activeTabIndex !== 2) this.switchTab(2)
          return
        }
        const {token, error} = tokenResult || {}
        if(error){
          swal('Error!', 'There was an issue with your payment', 'error')
          this.loading = false
          return
        }
        tokenId = token.id
      }

      this.loading = true
      let tok = await this.getAuthToken()
      let config = {headers: {Authorization: tok}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/'+ companyId + '/groups/' + companyGroupId + '/transactions'
      let data = {
        amount: this.getTotal(),
        subtotal: this.subtotal,
        tax: this.valuesAfterTaxFeeWaiver().total_tax,
        discount: this.getDiscounts(),
        no_confirmation_email: this.no_confirmation_email,
        send_payment_request: this.send_payment_request,
        promo_codes: this.promos,
        payment: this.payment,
        fee: this.valuesAfterTaxFeeWaiver().total_fee,
        waive_taxes: this.waive_tax ? 1 : 0,
        waive_fees: this.waive_fee ? 1 : 0,
        total: this.valuesAfterTaxFeeWaiver().total,
        user: {
          ...this.user,
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        bookings: this.cart,
        custom_field_responses: this.customFieldResponsesPayload()
      }

      if (isStoredCard) {
        // Use stored payment method
        data.payment_method_id = this.selectedStoredCard.payment_method_id
        data.stripe_customer_id = this.stripe_customer?.stripe_customer_id
      } else {
        data.token = tokenId
        // Include save card option if available
        if (this.save_card_for_future && (this.user.end_user_id || this.user.email)) {
          data.save_card = true
          if (this.user.end_user_id) {
            data.customer_id = this.user.end_user_id
          }
        }
      }

      if(this.pay_partial_amount){
        if(parseFloat(this.partial_amount) > parseFloat(this.total)){
          this.errs.partial_amount = 'Amount cannot be greater than total'
          this.pa_key++
          this.loading = false
          return
        } else {
          this.errs.partial_amount = ''
          this.pa_key++
        }
        data.partial_amount = this.partial_amount
      }
      data.user.phone = data.user.phone === null ? '' : data.user.phone

      this.axios.put(url, data, config)
        .then(response => {
          this.loading = false
          swal('Success!', 'The transaction was created', 'success')
          localStorage.removeItem('cart')
          localStorage.removeItem('taxes')
          localStorage.removeItem('customer')
          this.resetStripePaymentMethods()
          this.addAnotherBooking()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status == 500) {
            swal({
              title: 'Error!',
              text: err.response.data,
              type: 'error',
            })
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    isEmailValid(emailString) {
      return isValidEmail(emailString);
    },
    async fetchInternalCustomFields(){
      this.loadingCustomFields = true
      try {
        const token = await this.getAuthToken()
        const config = {headers: {Authorization: token}}
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/custom-fields/internal'
        const response = await axios.get(url, config)
        this.internalCustomFields = (response.data && response.data.internal_custom_fields) || []
      } catch (err) {
        console.error('Failed to fetch internal custom fields:', err)
        this.internalCustomFields = []
      } finally {
        this.loadingCustomFields = false
      }
    },
    customFieldResponsesPayload(){
      return buildCustomFieldResponsesPayload(this.visibleCustomFields, this.customFieldResponses)
    },
    async createBooking(){
      if(this.loading) return

      this.errs.payment = ''
      this.errs.email = ''
      this.errs.phone = ''

      if(this.visibleCustomFields.length > 0){
        // The custom-fields renderer is v-if'd under activeTabIndex === 1, so $refs.cfRenderer
        // is only defined while we're on the Customer tab. Switch over to validate, then
        // restore the original tab so any later error (Square tokenization, etc.) is shown
        // in context. Stay on Customer tab only when validation actually fails.
        const originalTab = this.activeTabIndex
        if(this.activeTabIndex !== 1){
          this.switchTab(1)
          await this.$nextTick()
        }
        if(this.$refs.cfRenderer && !this.$refs.cfRenderer.validate()){
          return
        }
        if(originalTab !== 1){
          this.switchTab(originalTab)
          await this.$nextTick()
        }
      }

      this.loading = true

      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId +  '/groups/' + companyGroupId +'/transactions'

      if(this.user.first_name === '' || this.user.last_name === '' || !this.isEmailValid(this.user.email)){
        if(!this.isEmailValid(this.user.email)){
          this.errs.email = 'Invalid email'
        } else {
          this.errs.email = ''
        }
        if(this.activeTabIndex !== 1){
          this.switchTab(1)
          await this.$nextTick()
        }
        swal('Ooops!', 'You must assign a customer to the transaction.', 'error')
        this.loading = false
        return
      }

      if(this.cart.length > 0 && !validateInternalCustomerPhone(this.user, JSON.parse(localStorage.getItem('group') || '{}'))){
        this.errs.phone = 'Phone number is required'
        if(this.activeTabIndex !== 1){
          this.switchTab(1)
          await this.$nextTick()
        }
        swal('Ooops!', 'A phone number is required for this booking.', 'error')
        this.loading = false
        return
      } else {
        this.errs.phone = ''
      }

      if(this.add_payment === true && this.pay_partial_amount && (!(parseFloat(this.partial_amount) > 0) || parseFloat(this.partial_amount) > parseFloat(this.total))){
        this.errs.partial_amount = parseFloat(this.partial_amount) > parseFloat(this.total)
          ? 'Amount cannot be greater than total'
          : 'Amount must be greater than zero. Select Pay on arrival to send a payment request without taking payment.'
        this.pa_key++
        if(this.activeTabIndex !== 2) this.switchTab(2)
        this.loading = false
        return
      }

      if(this.add_payment === true && (!this.selectedPaymentOption || !this.selectedPaymentOption.name)){
        this.errs.payment = 'Select a payment method.'
        if(this.activeTabIndex !== 2) this.switchTab(2)
        swal('Ooops!', 'Select a payment method.', 'error')
        this.loading = false
        return
      }
      // Catch the case where the user clicks Create without ever opening the Payment tab,
      // so the SDK was never initialized (this.stripe/this.card are still ''). Stale-Element
      // cases (user opened the tab, switched away, clicked Create) are handled by the try/catch
      // around createToken/tokenize — checking #card-element children here false-positives when
      // Vue render timing hasn't reflected the iframe yet, even though the user has typed into it.
      if(this.add_payment === true && this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 3 && this.selected_payment_method === 'new'){
        if(!this.stripe || typeof this.stripe.createToken !== 'function' || !this.card){
          this.errs.payment = 'Open the Payment tab and enter card details, or select "Pay on arrival".'
          if(this.activeTabIndex !== 2) this.switchTab(2)
          swal('Ooops!', 'Enter card details on the Payment tab, or select "Pay on arrival".', 'error')
          this.loading = false
          return
        }
        // Empty or incomplete card → don't call createToken (Stripe fires an internal
        // unhandled rejection on createToken with an empty Element). Show inline error.
        if(!this.card_complete){
          this.card_error_message = this.card_error_message || 'Enter your card number, expiry, and CVC.'
          if(this.activeTabIndex !== 2) this.switchTab(2)
          this.loading = false
          return
        }
      }
      if(this.add_payment === true && this.selectedPaymentOption.name === 'Card' && this.payment_settings.payment_gateway_id === 2 && this.selected_payment_method === 'new'){
        if(!this.square || !this.card){
          this.errs.payment = 'Open the Payment tab and enter card details, or select "Pay on arrival".'
          if(this.activeTabIndex !== 2) this.switchTab(2)
          swal('Ooops!', 'Enter card details on the Payment tab, or select "Pay on arrival".', 'error')
          this.loading = false
          return
        }
      }


      if(this.add_payment === false){
        let data = {
          bookings: this.cart,
          custom_field_responses: this.customFieldResponsesPayload(),
          subtotal: this.subtotal,
          inclusive_taxes: this.hasInclusiveTaxes,
          tax: this.valuesAfterTaxFeeWaiver().total_tax,
          discount: this.getDiscounts(),
          no_confirmation_email: this.no_confirmation_email,
          promo_codes: this.promos,
          partial_amount: 0,
          fee: this.valuesAfterTaxFeeWaiver().total_fee,
          waive_taxes: this.waive_tax ? 1 : 0,
          waive_fees: this.waive_fee ? 1 : 0,
          total: this.valuesAfterTaxFeeWaiver().total,
          user: {
            ...this.user,
            phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
          },
          send_payment_request: this.send_payment_request
        }
        // loading already set at start of createBooking
        this.axios.put(url, data, config)
          .then(response => {
            this.loading = false
            swal('Success!', 'The transaction was created', 'success')
            localStorage.removeItem('cart')
            localStorage.removeItem('taxes')
            localStorage.removeItem('customer')
            this.send_payment_request = false
            this.addAnotherBooking()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else if (err.response.status == 500) {
              swal('Error!', err.response.data, 'error')
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      }
      else if (!this.selectedPaymentOption.is_default || this.selectedPaymentOption.name === 'Yappy' ||
        this.selectedPaymentOption.name === 'Cash'
        || this.selectedPaymentOption.name === 'POS payment'){
        let payment_type = 'pos'
        if(this.selectedPaymentOption.name === 'Cash'){
          payment_type = 'cash'
        }
        if(!this.selectedPaymentOption.is_default){
          payment_type = this.selectedPaymentOption.name
        }
        if(this.selectedPaymentOption.name === 'Yappy'){
          payment_type = 'Yappy'
        }
        let data = {
          bookings: this.cart,
          custom_field_responses: this.customFieldResponsesPayload(),
          subtotal: this.subtotal,
          tax: this.valuesAfterTaxFeeWaiver().total_tax,
          discount: this.getDiscounts(),
          no_confirmation_email: this.no_confirmation_email,
          send_payment_request: this.send_payment_request,
          promo_codes: this.promos,
          fee: this.valuesAfterTaxFeeWaiver().total_fee,
          waive_taxes: this.waive_tax ? 1 : 0,
          waive_fees: this.waive_fee ? 1 : 0,
          total: this.valuesAfterTaxFeeWaiver().total,
          user: {
            ...this.user,
            phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
          },
          payment_type: payment_type,
          payment: this.payment,
          custom_payment_type: !this.selectedPaymentOption.is_default
        }

        if(this.pay_partial_amount){
          if(parseFloat(this.partial_amount) > parseFloat(this.total)){
            this.errs.partial_amount = 'Amount cannot be greater than total'
            this.pa_key++
            this.loading = false
            return
          } else {
            this.errs.partial_amount = ''
            this.pa_key++
          }
          data.partial_amount = this.partial_amount
        }
        data.user.phone = data.user.phone === null ? '' : data.user.phone

        // loading already set at start of createBooking
        this.axios.put(url, data, config)
          .then(response => {
            this.loading = false
            swal('Success!', 'The transaction was created', 'success')
            localStorage.removeItem('cart')
            localStorage.removeItem('taxes')
            localStorage.removeItem('customer')
            this.addAnotherBooking()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else if (err.response.status == 500) {
              swal('Error!', err.response.data, 'error')
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      }
      else if(this.payment_settings.payment_gateway_id === 3 && this.selectedPaymentOption.name === 'Card' ){
        let stripePayment = await this.handleStripePayment('new')
      }
      else if(this.payment_settings.payment_gateway_id === 2 && this.selectedPaymentOption.name === 'Card' ){
        let squarePayment = await this.createSquarePayment()
      } else if(this.payment_settings.payment_gateway_id === 4 && this.selectedPaymentOption.name === 'Card' ){
        let payStack = await this.payWithPaystack()
      }
      else {
        let payment = {}
        if(this.selectedPaymentOption.name === 'Card'){
          if (this.payment_settings.payment_gateway_id === 1) {
            if (!this.$refs.authorizePaymentForm) {
              this.errs.payment = 'Enter card details below or select Pay on arrival.'
              this.switchTab(2)
              await this.$nextTick()
              this.loading = false
              return
            }
            try {
              this.authorize_opaque_data = await this.$refs.authorizePaymentForm.tokenize()
            } catch (err) {
              this.$notify({ type: 'danger', message: err.message })
              this.loading = false
              return
            }
            payment = {
              opaqueData: this.authorize_opaque_data,
              zip: this.$refs.authorizePaymentForm.zip
            }
          } else {
            if(!this.is_valid_card()){
              this.loading = false
              return
            }
            const formData = this.$refs.paymentForm.getFormData()
            if (!formData) {
              this.loading = false
              return
            }
            payment = {
              cardNumber: formData.cardNumber,
              expirationDate: formData.expirationDate,
              cardCode: formData.cardCode,
              zip: formData.zip
            }
          }
        }
        let data = {
          bookings: this.cart,
          custom_field_responses: this.customFieldResponsesPayload(),
          subtotal: this.subtotal,
          tax: this.valuesAfterTaxFeeWaiver().total_tax,
          fee: this.valuesAfterTaxFeeWaiver().total_fee,
          waive_taxes: this.waive_tax ? 1 : 0,
          waive_fees: this.waive_fee ? 1 : 0,
          discount: this.getDiscounts(),
          no_confirmation_email: this.no_confirmation_email,
          send_payment_request: this.send_payment_request,
          promo_codes: this.promos,
          total: this.valuesAfterTaxFeeWaiver().total,
          user: {
            ...this.user,
            phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
          },
          payment: payment
        }

        if(this.selectedPaymentOption.name === 'Customer credit'){
          if(parseFloat(this.applied_credit) > parseFloat(this.total)){
            swal('Ooops!', 'Charged amount cannot be greater than the total value of the booking.', 'error')
            this.loading = false
            return
          }
          if(parseFloat(this.applied_credit) > parseFloat(this.available_credit)){
            swal('Ooops!', 'You cannot apply more credits than available.', 'error')
            this.loading = false
            return
          }
          data.customer_credit = this.applied_credit
        }

        if(this.selectedPaymentOption.name === 'Gift card'){
          if(!this.gift_card_code
            || !this.selectedGiftCardCode.hasOwnProperty('id')
            || this.getGiftCardCode(this.selectedGiftCardCode.code) !== this.gift_card_code){
            this.errs.gift_card_code = 'You must choose a valid gift card'
            this.loading = false
            return
          } else {
            this.errs.gift_card_code = ''
          }
          data.applied_gift_card = this.selectedGiftCardCode
          data.payment_type = 'gift_card'
        }
        if(this.pay_partial_amount){
          if(parseFloat(this.partial_amount) > parseFloat(this.total)){
            this.errs.partial_amount = 'Amount cannot be greater than total'
            this.pa_key++
            this.loading = false
            return
          } else {
            this.errs.partial_amount = ''
            this.pa_key++
          }
          data.partial_amount = this.partial_amount
        }
        data.user.phone = data.user.phone === null ? '' : data.user.phone
        // loading already set at start of createBooking
        this.axios.put(url, data, config)
          .then(response => {
            this.loading = false
            swal('Success!', 'The transaction was created', 'success')
            localStorage.removeItem('cart')
            localStorage.removeItem('taxes')
            localStorage.removeItem('customer')
            this.addAnotherBooking()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else if (err.response.status == 500) {
              swal('Error!', err.response.data, 'error')
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      }
    },
    is_valid_card(){
      return this.$refs.paymentForm.validateAll()
    },
    clearCustomer(){
      this.lookup_value = ''
      this.user = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        end_user_id: null
      }
      this.resetStripePaymentMethods()
    },
    async tokenize(paymentMethod) {
      const tokenResult = await paymentMethod.tokenize();

      if (tokenResult.status === 'OK') {
        const zip = tokenResult.details.billing.postalCode ? tokenResult.details.billing.postalCode : ''
        return {token: tokenResult.token, zip}
      } else {
        // Attach the raw Square errors array so the caller can render an inline,
        // user-friendly message instead of swal-ing the stringified JSON.
        const err = new Error(`Tokenization failed with status: ${tokenResult.status}`)
        err.tokenizationStatus = tokenResult.status
        err.tokenizationErrors = Array.isArray(tokenResult.errors) ? tokenResult.errors : []
        throw err
      }
    },
    async createSquarePayment(type){
      this.loading = true
      const isStoredCard = this.selected_payment_method !== 'new' && this.selectedSquareStoredCard

      try {
        let tok = await this.getAuthToken()
        let config = {headers: {Authorization: tok}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/'+ companyId + '/groups/' + companyGroupId + '/transactions'
        let data = {
          amount: this.total,
          subtotal: this.subtotal,
          tax: this.valuesAfterTaxFeeWaiver().total_tax,
          discount: this.getDiscounts(),
          no_confirmation_email: this.no_confirmation_email,
          send_payment_request: this.send_payment_request,
          promo_codes: this.promos,
          fee: this.valuesAfterTaxFeeWaiver().total_fee,
          waive_taxes: this.waive_tax ? 1 : 0,
          waive_fees: this.waive_fee ? 1 : 0,
          total: this.valuesAfterTaxFeeWaiver().total,
          user: {
            ...this.user,
            phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
          },
          bookings: this.cart,
          custom_field_responses: this.customFieldResponsesPayload(),
          locationId: this.squareLocationId,
          payment: this.payment
        }

        if (isStoredCard) {
          // Use stored card
          data.square_card_id = this.selectedSquareStoredCard.card_id
          data.square_customer_id = this.square_customer?.square_customer_id
        } else {
          // Tokenize new card
          const token = await this.tokenize(this.card);
          const verificationToken = await this.verifyBuyer(this.square, token.token, token.zip);
          data.sourceId = token.token
          data.verificationToken = verificationToken
          data.payment.zip = token.zip

          // Include save card option if available
          if (this.save_card_for_future && (this.user.end_user_id || this.user.email)) {
            const token2 = await this.tokenize(this.card);
            data.sourceId2 = token2.token
            data.save_card = true
          }
        }

        if(this.pay_partial_amount){
          if(parseFloat(this.partial_amount) > parseFloat(this.total)){
            this.errs.partial_amount = 'Amount cannot be greater than total'
            this.pa_key++
            this.loading = false
            return
          } else {
            this.errs.partial_amount = ''
            this.pa_key++
          }
          data.partial_amount = this.partial_amount
        }
        data.user.phone = data.user.phone === null ? '' : data.user.phone

        this.axios.put(url, data, config)
          .then(response => {
            this.loading = false
            swal('Success!', 'The transaction was created', 'success')
            localStorage.removeItem('cart')
            localStorage.removeItem('taxes')
            localStorage.removeItem('customer')
            this.addAnotherBooking()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else if (err.response.status == 500) {
              swal('Error!', err.response.data, 'error')
            } else {
              swal('Error!', 'Something went wrong', 'error')
            }
          })
      } catch (error) {
        this.loading = false
        // tokenize() attaches the raw Square errors array on validation failures.
        // Square renders its own inline error on the card form for these cases, so we
        // stay silent — just stop the spinner and let the user fix the fields.
        // Anything else (network, verifyBuyer, stale Element) falls back to a swal.
        const tokenizationErrors = Array.isArray(error?.tokenizationErrors) ? error.tokenizationErrors : []
        const allValidation = tokenizationErrors.length > 0
          && tokenizationErrors.every(e => e?.type === 'VALIDATION_ERROR')
        if(allValidation){
          // Square renders the inline error inside its iframe on the Payment tab.
          // If the user clicked Create from another tab, switch so the error is visible.
          if(this.activeTabIndex !== 2) this.switchTab(2)
          return
        }
        console.error('Square createSquarePayment failed', error)
        swal('Error!', error?.message || 'There was an issue with your payment. Re-enter card details on the Payment tab.', 'error')
      }

    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async promoSearch(queryString, cb){
      let today = new Date()
      let purchase_date = today.getFullYear() +  "-" +  ('0' + (today.getMonth() + 1)).slice(-2) + "-" + ('0' + today.getDate()).slice(-2);

      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/promos?autocomplete=' + encodeURIComponent(queryString) + '&purchase_date=' + purchase_date
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          if(response.data.hasOwnProperty('gift_card')){
            this.selectedPromoCode = response.data.gift_card
          }
          for(let n in response.data.promos){
            // Bundle price promos are excluded from this picker: this
            // surface's local discount math does not evaluate bundle rules,
            // so offering them would charge an undiscounted total that
            // diverges from the recompute. Apply them from the booking
            // drawer or transaction details instead.
            const hasBundleRule = (response.data.promos[n].rules || []).some(r => r.rule_type?.rule_key === 'BUNDLE_PRICE');
            if(response.data.promos[n].name != null && !hasBundleRule){
              suggestions.push({
                value: JSON.stringify(response.data.promos[n]),
                id: response.data.promos[n].id,
                name: response.data.promos[n].name,
                description: response.data.promos[n].description,
                value_amount: response.data.promos[n].value_amount,
                redemption_type: response.data.promos[n].redemption_type,
                value_type: response.data.promos[n].value_type,
                games: JSON.parse(response.data.promos[n].games),
                event_exlusions: response.data.promos[n].event_exlusions,
                internal_only: response.data.promos[n].internal_only,
                is_cross_group: response.data.promos[n].is_cross_group,
                event_is_date_range: response.data.promos[n].event_is_date_range,
                event_is_time_range: response.data.promos[n].event_is_time_range,
                event_start_date: response.data.promos[n].event_start_date,
                event_end_date: response.data.promos[n].event_end_date,
                event_start_time: response.data.promos[n].event_start_time,
                event_end_time: response.data.promos[n].event_end_time,
                available_days: [response.data.promos[n].available_sunday,
                  response.data.promos[n].available_monday,
                  response.data.promos[n].available_tuesday,
                  response.data.promos[n].available_wednesday,
                  response.data.promos[n].available_thursday,
                  response.data.promos[n].available_friday,
                  response.data.promos[n].available_saturday],
                rules: response.data.promos[n].rules || []
              })
            }

          }
          const results = queryString
            ? suggestions.filter(this.createFilter(queryString))
            : suggestions;

          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async querySearch(queryString, cb) {
      //make API call to /customers with queryString as filter
      var token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/customers?count=10000000&offset=0&first_name=&last_name=&email=&phone=&game=&tag=&autocomplete=' + encodeURIComponent(queryString)
      axios.get(url, config)
        .then(response => {
          let suggestions = []
          for(let n in response.data.customers){
            if(response.data.customers[n].email != null
              && response.data.customers[n].first_name != null
              && response.data.customers[n].first_name != ''){
              suggestions.push({
                value: JSON.stringify(response.data.customers[n]),
                email: response.data.customers[n].email,
                end_user_id: response.data.customers[n].end_user_id,
                id: response.data.customers[n].id,
                first_name: response.data.customers[n].first_name,
                last_name: response.data.customers[n].last_name,
                phone: this.formatPhone(response.data.customers[n].country, response.data.customers[n].phone)
              })
            }

          }


          const results = suggestions;

          cb(results)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    createFilter(queryString) {
      return (suggestion) => {
        return diacriticIncludes(suggestion.value, queryString);
      };
    },
    updateCustomer(){
      localStorage.setItem('customer', JSON.stringify(this.user))
      this.getCredits(this.user)
    },
    getAvailableCredit(){
      let available = 0
      for(let n in this.customer_credits){
        available = available + parseFloat(this.customer_credits[n].remaining)
      }
      this.available_credit = available.toFixed(2)
      if(parseFloat(this.available_credit) < parseFloat(this.subtotal)){
        this.applied_credit = this.available_credit
      } else {
        this.applied_credit = this.subtotal
      }
    },
    handleSelect(item){
      this.lookup_value = item.email
      this.user.first_name = item.first_name
      this.user.last_name = item.last_name
      this.user.email = item.email
      this.user.phone = item.phone
      this.user.end_user_id = item.end_user_id
      //update LS
      localStorage.setItem('customer', JSON.stringify(item))
      this.getCredits(item)

      // Fetch Stripe customer data if applicable
      if (this.payment_settings.payment_gateway_id === 3 && item.end_user_id) {
        this.getStripeCustomer(item.end_user_id)
      }
    },
    async getCredits(item){
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/customers/' + item.end_user_id + '/customer-credit'
      axios.get(url, config)
        .then(response => {
          this.customer_credits = response.data.customer_credits
          this.getAvailableCredit()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    saveBooking(index){
      let pricing =  JSON.parse(this.cart[index].price)
      if(this.price_override[index]){
        if(pricing[0].min_players !== 0){
          this.cart[index].total = parseFloat(this.cart[index].ppp) * parseInt(this.cart[index].group_size)
        } else {
          this.cart[index].total = this.cart[index].ppg
        }
      } else {
        if(pricing[0].min_players === 0){
          this.cart[index].total = pricing[0].price
        } else {
          for(let m in pricing){
            if(pricing[m].min_players >= this.cart[index].group_size && pricing[m].max_players <= this.cart[index].group_size){
              this.cart[index].ppp = parseFloat(pricing[m].price)
              this.cart[index].total  = this.cart[index].group_size *  parseFloat(pricing[m].price)
            }
          }
          if(this.cart[index].group_size > pricing[pricing.length -1].min_players){
            this.cart[index].ppp = parseFloat(pricing[pricing.length -1].price)
            this.cart[index].total = (parseFloat(this.cart[index].group_size) * parseFloat(pricing[pricing.length -1].price))
          }
        }
      }

      localStorage.setItem('cart', JSON.stringify(this.cart))
      if(this.waive_tax){
        this.waiveTaxes()
      } else {
        this.getSubTotal()
        this.getTaxes()
        this.getFees()
        this.getTotal()
      }
      this.$set(this.editing, index, false);
      this.$set(this.price_override, index, false);
    },
    editBooking(index){
      this.$set(this.editing, index, true);
    },
    addAnotherBooking(){
      this.$router.push('/bookings')
    },
    cancelTransaction(){
      swal('Are you sure?', 'This will remove all items from cart', 'warning')
        .then((response)=> {
          localStorage.removeItem('cart')
          localStorage.removeItem('taxes')
          localStorage.removeItem('customer')
          this.resetStripePaymentMethods()
          this.$router.push('/bookings')
        })
    },
    switchTab(index){
      this.activeTabIndex = index
      for(let n in this.categories){
        this.categories[n].active = false
      }
      this.categories[index].active = true
      this.j++

      if(this.activeTabIndex === 2){
        this.getPaymentGateway()
      }
    },
    getTotal(){
      let total_tax = 0
      if(!this.waive_tax){
        for(let n in this.taxes){
          if(this.taxes[n].hasOwnProperty('computed_amount') && this.taxes[n].pricing_type === 0){
            total_tax +=this.taxes[n].computed_amount
          }
        }
      }

      let total_fee = 0
      if(!this.waive_fee){
        total_fee = this.getFees()
      }

      // Reconcile inclusive tax savings: compute shelf-price discount for flat promos
      // and use shelfDiscount - exTaxDiscount as the savings (avoids penny rounding drift)
      let inclusiveTaxSavings = 0
      if(!this.waive_tax){
        let exTaxDiscount = this.getDiscounts()
        let shelfDiscount = this.getShelfPriceDiscounts()
        inclusiveTaxSavings = roundCents(shelfDiscount - exTaxDiscount)
        if(inclusiveTaxSavings < 0) inclusiveTaxSavings = 0
      }

      this.total = roundCents(parseFloat(this.subtotal) + parseFloat(total_tax) + parseFloat(total_fee) - parseFloat(this.getDiscounts()) - inclusiveTaxSavings)
      return this.total
    },
    // Combined inclusive rate for one cart line (value_type 2 always, value_type 4 when it
    // applies to the game) or, with no game, for the whole transaction (value_type 2 plus
    // value_type 4 on all items). A shelf price includes every inclusive tax at once, so
    // each tax extracts its base with this rate and takes its own share. Mirrors
    // update-transaction-values buildInclusiveRateLookup.
    inclusiveRateFor(gameId = null){
      let rate = 0
      for(let t in this.taxes){
        const tax = this.taxes[t]
        if(tax.pricing_type !== 1) continue
        if(tax.value_type !== 2 && tax.value_type !== 4) continue
        if(tax.value_type === 4 && !tax.apply_to_all_items){
          if(gameId === null) continue
          const linked = typeof tax.linked_games === 'string' ? JSON.parse(tax.linked_games) : (tax.linked_games || [])
          if(!_.find(linked, {id: gameId})) continue
        }
        rate += Number(tax.amount) || 0
      }
      return rate
    },
    getBasePriceForDiscount(price){
      let combinedRate = 0
      for(let t in this.taxes){
        if(this.taxes[t].pricing_type !== 1) continue
        if(this.taxes[t].value_type !== 2 && this.taxes[t].value_type !== 4) continue
        if(!this.taxes[t].apply_after_discount) continue
        if(!this.taxes[t].apply_to_all_items){
          // For NewTransaction, check against all cart game IDs
          let linked_games = typeof this.taxes[t].linked_games === 'string' ? JSON.parse(this.taxes[t].linked_games) : this.taxes[t].linked_games
          let hasMatch = false
          for(let n in this.cart){
            if(_.find(linked_games, {id: this.cart[n].game_id})) hasMatch = true
          }
          if(!hasMatch) continue
        }
        combinedRate += this.taxes[t].amount
      }
      if(combinedRate === 0) return price
      return roundCents(price / (1 + (combinedRate * 0.01)))
    },
    getDiscount(promo){
      let discount = 0

      // Check for BUY_X_GET_Y rule first
      const buyXGetYRule = promo.rules?.find(r => r.rule_type?.rule_key === 'BUY_X_GET_Y')

      if (buyXGetYRule) {
        // Parse rule_config if it's a string (backend may return it as JSON string)
        let ruleConfig = buyXGetYRule.rule_config

        if (typeof ruleConfig === 'string') {
          try {
            ruleConfig = JSON.parse(ruleConfig)
          } catch (e) {
            console.error('Failed to parse rule_config:', e)
            ruleConfig = null
          }
        }
        if (ruleConfig) {
          discount = this.calculateBuyXGetYDiscount(promo, ruleConfig)
        }
      } else if(promo.value_type === 0){
        if(promo.redemption_type === 1){
          //Flat — convert to ex-tax so inclusive tax savings are computed correctly
          discount = this.getBasePriceForDiscount(promo.value_amount)
          if(discount > this.subtotal) discount = this.subtotal
        } else {
          // Per-line round-then-sum to match backend update-transaction-values.
          // Summing first then rounding drifts by ~½¢ per line on fractional
          // results (e.g. 15% of $99.98 = 14.997: per-line rounds to 15.00
          // × 2 = 30.00, but 199.96 × 15% rounded once is 29.99).
          for(let m in this.cart){
            let lineBase = this.getBasePriceForDiscount(this.cart[m].total || 0)
            discount += this.getPercentage(promo.value_amount, lineBase)
          }
        }
      } else if(promo.value_type === 1){
        if(promo.redemption_type === 1){
          //Flat — convert to ex-tax so inclusive tax savings are computed correctly
          discount = this.getBasePriceForDiscount(promo.value_amount) * this.cart.length
          if(discount > this.subtotal) discount = this.subtotal
        } else {
          // Per-line round-then-sum to match backend update-transaction-values.
          for(let m in this.cart){
            let lineBase = this.getBasePriceForDiscount(this.cart[m].total || 0)
            discount += this.getPercentage(promo.value_amount, lineBase)
          }
        }
      }
      else if(promo.value_type === 2){
        let number_of_players = 0

        for(let m in this.cart){
          for(let k in this.cart[m].promos){
            if(this.cart[m].promos[k].id === promo.id){
              number_of_players += this.cart[m].group_size
            }
          }
        }
        if(promo.redemption_type === 1){
          //Flat — convert per-unit to ex-tax, then multiply by quantity
          discount = this.getBasePriceForDiscount(promo.value_amount) * number_of_players
          if(discount > this.subtotal) discount = this.subtotal
        } else {
          // Per-line × quantity round-then-sum, matching backend
          // update-transaction-values: Math.round(basePrice × value_amount × qty) per line.
          for(let m in this.cart){
            let applies = (this.cart[m].promos || []).some(p => p.id === promo.id)
            if(!applies) continue
            let qty = this.cart[m].group_size || 0
            let lineBase = this.getBasePriceForDiscount(this.cart[m].total || 0)
            discount += this.getPercentage(promo.value_amount * qty, lineBase)
          }
        }
      }
      discount = roundCents(parseFloat(discount))
      promo.applied_discount = discount
      return discount
    },
    getShelfDiscount(promo){
      let discount = 0
      if(promo.value_type === 0 || promo.value_type === 1){
        if(promo.redemption_type === 1){
          discount = promo.value_amount
          if(discount > this.subtotal) discount = this.subtotal
        } else {
          // Per-line round-then-sum to match backend update-transaction-values.
          for(let m in this.cart){
            discount += this.getPercentage(promo.value_amount, this.cart[m].total || 0)
          }
        }
      } else if(promo.value_type === 2){
        let number_of_players = 0
        for(let m in this.cart){
          for(let k in this.cart[m].promos){
            if(this.cart[m].promos[k].id === promo.id){
              number_of_players += this.cart[m].group_size
            }
          }
        }
        if(promo.redemption_type === 1){
          discount = promo.value_amount * number_of_players
          if(discount > this.subtotal) discount = this.subtotal
        } else {
          // Per-line × quantity round-then-sum, matching backend
          // update-transaction-values: Math.round(price × value_amount × qty) per line.
          for(let m in this.cart){
            let applies = (this.cart[m].promos || []).some(p => p.id === promo.id)
            if(!applies) continue
            let qty = this.cart[m].group_size || 0
            discount += this.getPercentage(promo.value_amount * qty, this.cart[m].total || 0)
          }
        }
      }
      return roundCents(parseFloat(discount))
    },
    calculateBuyXGetYDiscount(promo, ruleConfig) {
      const { required_items, discounted_items } = ruleConfig

      // Step 1: Find items that match X requirement and items that match Y requirement
      const { item_type: xItemType, item_ids: xItemIds, min_quantity: xMinQty } = required_items
      const { item_type: yItemType, item_ids: yItemIds, discount_type, discount_value, max_quantity: yMaxQty } = discounted_items

      // Check if X and Y overlap (same item type and overlapping item IDs)
      const xAndYOverlap = this.checkXYOverlap(required_items, discounted_items)

      if (xAndYOverlap) {
        return this.calculateOverlappingDiscount(ruleConfig)
      }

      // Non-overlapping: X items are separate from Y items
      const xSatisfiedCount = this.countXSatisfied(required_items)

      if (xSatisfiedCount === 0) {
        return 0
      }

      // Step 3: Find Y items in cart
      let discountableItems = []
      if (yItemType === 'games' || yItemType === 'any') {
        for (const cartItem of this.cart) {
          const gameId = Number(cartItem.game_id)
          const matchesItemIds = !yItemIds || yItemIds.length === 0 ||
            yItemIds.some(id => Number(id) === gameId)

          if (matchesItemIds) {
            discountableItems.push({
              id: cartItem.game_id,
              price: cartItem.total,
              quantity: 1
            })
          }
        }
      }

      if (discountableItems.length === 0) {
        return 0
      }

      // Step 4: Apply discount to Y items (up to max_quantity per X satisfied)
      const maxDiscountableQty = (yMaxQty || 1) * xSatisfiedCount
      let itemsToDiscount = Math.min(discountableItems.length, maxDiscountableQty)
      // Sort by price descending to discount the most expensive items first
      discountableItems.sort((a, b) => b.price - a.price)

      let totalDiscount = 0
      for (let i = 0; i < itemsToDiscount; i++) {
        const item = discountableItems[i]
        let itemDiscount = 0

        if (discount_type === 'free') {
          // 100% off
          itemDiscount = item.price
        } else if (discount_type === 'percentage') {
          // percentage off
          itemDiscount = this.getPercentage(discount_value, item.price)
        } else if (discount_type === 'fixed') {
          // fixed amount off
          itemDiscount = Math.min(discount_value, item.price)
        }

        totalDiscount += itemDiscount
      }

      // Don't exceed subtotal
      if (totalDiscount > this.subtotal) {
        totalDiscount = this.subtotal
      }

      return totalDiscount
    },
    countXSatisfied(requiredConfig) {
      const { item_type, item_ids, min_quantity, match_mode } = requiredConfig

      console.log('countXSatisfied - requiredConfig:', JSON.stringify(requiredConfig))
      console.log('countXSatisfied - min_quantity from config:', min_quantity)

      // Count items in cart that match the X requirement
      let totalQuantity = 0

      if (item_type === 'games' || item_type === 'any') {
        for (const cartItem of this.cart) {
          // Convert to number for comparison (handles string/int mismatch)
          const gameId = Number(cartItem.game_id)
          // If specific items required, check if this item matches
          const matchesItemIds = !item_ids || item_ids.length === 0 ||
            item_ids.some(id => Number(id) === gameId)

          if (matchesItemIds) {
            totalQuantity += 1 // Each booking counts as 1
          }
        }
      }

      // Return how many times the X requirement is satisfied
      const minQty = min_quantity || 1
      console.log('countXSatisfied - totalQuantity:', totalQuantity, 'minQty used:', minQty, 'result:', Math.floor(totalQuantity / minQty))
      return Math.floor(totalQuantity / minQty)
    },
    checkXYOverlap(requiredItems, discountedItems) {
      // Check if X and Y item types are the same (or compatible)
      const xType = requiredItems.item_type
      const yType = discountedItems.item_type

      // Different types = no overlap
      if (xType !== yType && xType !== 'any' && yType !== 'any') {
        return false
      }

      const xIds = requiredItems.item_ids || []
      const yIds = discountedItems.item_ids || []

      // If either has no specific IDs (applies to all), they overlap
      if (xIds.length === 0 || yIds.length === 0) {
        return true
      }

      // Check if any IDs overlap
      const xIdSet = new Set(xIds.map(id => Number(id)))
      for (const yId of yIds) {
        if (xIdSet.has(Number(yId))) {
          return true
        }
      }

      return false
    },
    calculateOverlappingDiscount(ruleConfig) {
      const { required_items, discounted_items } = ruleConfig
      const xMinQty = required_items.min_quantity || 1
      const yMaxQty = discounted_items.max_quantity || 1
      const { discount_type, discount_value } = discounted_items
      const yItemIds = discounted_items.item_ids || []

      // Find all cart items that could be part of this promo (match both X and Y criteria)
      // Store reference to original cart item so we can update its discount
      let eligibleItems = []
      for (let i = 0; i < this.cart.length; i++) {
        const cartItem = this.cart[i]
        const gameId = Number(cartItem.game_id)

        // Item must match Y criteria to be discountable
        const matchesY = yItemIds.length === 0 || yItemIds.some(id => Number(id) === gameId)

        if (matchesY) {
          eligibleItems.push({
            id: gameId,
            price: cartItem.total,
            cartIndex: i // Track which cart item this is
          })
        }
      }

      if (eligibleItems.length === 0) {
        return 0
      }

      // Bundle size = items needed for X + items discounted for Y
      // E.g., "Buy 1 Get 1 Free" = bundle of 2 (1 paid + 1 free)
      const bundleSize = xMinQty + yMaxQty
      const numberOfBundles = Math.floor(eligibleItems.length / bundleSize)

      if (numberOfBundles === 0) {
        // Not enough items for even one complete bundle
        return 0
      }

      // Sort by price descending - discount the most expensive items
      eligibleItems.sort((a, b) => b.price - a.price)

      // Calculate discount: numberOfBundles * yMaxQty items get discounted
      const itemsToDiscount = numberOfBundles * yMaxQty
      let totalDiscount = 0

      for (let i = 0; i < itemsToDiscount && i < eligibleItems.length; i++) {
        const item = eligibleItems[i]
        let itemDiscount = 0

        if (discount_type === 'free') {
          itemDiscount = item.price
        } else if (discount_type === 'percentage') {
          itemDiscount = this.getPercentage(discount_value, item.price)
        } else if (discount_type === 'fixed') {
          itemDiscount = Math.min(discount_value, item.price)
        }

        // Store the discount on the cart item itself for accurate fee calculations
        this.cart[item.cartIndex].promo_discount = (this.cart[item.cartIndex].promo_discount || 0) + itemDiscount

        totalDiscount += itemDiscount
      }

      // Don't exceed subtotal
      if (totalDiscount > this.subtotal) {
        totalDiscount = this.subtotal
      }

      return totalDiscount
    },
    getDiscounts(){
      let total_discounts = 0
      for(let n in this.promos){
        total_discounts += this.promos[n].applied_discount
      }
      return roundCents(parseFloat(total_discounts))
    },
    getShelfPriceDiscounts(){
      let total = 0
      for(let n in this.promos){
        let promo = this.promos[n]
        if(promo.redemption_type === 1){
          // Flat: shelf price is the original value_amount
          if(promo.value_type === 0){
            total += promo.value_amount
          } else if(promo.value_type === 1){
            total += promo.value_amount * this.cart.length
          } else if(promo.value_type === 2){
            let number_of_players = 0
            for(let m in this.cart){
              for(let k in this.cart[m].promos){
                if(this.cart[m].promos[k].id === promo.id){
                  number_of_players += this.cart[m].group_size
                }
              }
            }
            total += promo.value_amount * number_of_players
          }
        } else {
          // Percentage: shelf = price * rate (not base * rate)
          if(promo.value_type === 0 || promo.value_type === 1){
            total += Number(Math.round(this.subtotal * promo.value_amount) + 'e-2')
          } else if(promo.value_type === 2){
            let number_of_players = 0
            let subtotal = 0
            for(let m in this.cart){
              for(let k in this.cart[m].promos){
                if(this.cart[m].promos[k].id === promo.id){
                  number_of_players += this.cart[m].group_size
                  subtotal += this.cart[m].total
                }
              }
            }
            total += Number(Math.round(subtotal * promo.value_amount * number_of_players) + 'e-2')
          }
        }
      }
      if(total > this.subtotal) total = this.subtotal
      return roundCents(total)
    },
    getSubTotal(){
      this.subtotal = 0
      for(let n in this.cart){
        this.subtotal += parseFloat(this.cart[n].total) // + taxes and fees
      }
      this.subtotal = roundCents(parseFloat(this.subtotal))
    },
    deleteBooking(index){
      this.cart.splice(index, 1)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      this.getBasket()
    },
    getBookingDate(d){
      return formattedDate(this.date_format, d)
    },
    getTime(d){
      return time(this.time_format, d)
    },
    async getBasket(){
      let cart = JSON.parse(localStorage.getItem('cart')) || []
      for(let m in cart){
        // null = the default duration; set before the array becomes reactive
        cart[m].selected_duration_id = cart[m].selected_duration_id === undefined ? null : cart[m].selected_duration_id
        await this.hydrateItemPricing(cart[m])
        this.seedTickets(cart[m])
        this.getBookingSubtotal(cart[m])

        cart[m].promos = []
        cart[m].promo_discount = 0
        cart[m].computed_total = cart[m].total
      }
      this.cart = cart

      this.getSubTotal()
      this.getTaxes()
      this.getFees()
      this.getTotal()
    },
    // The calendar snapshot in localStorage carries no duration data, so each item's pricing is read
    // from the slot pricing endpoint (the same one the booking drawer's cart lines use): every duration's
    // rows tagged, the duration list and the flags, keyed the way slotPricingRows expects. A failed
    // read leaves the snapshot's default-only pricing in place.
    async hydrateItemPricing(item){
      try {
        const token = await this.getAuthToken()
        const config = { headers: { Authorization: token } }
        const companyId = localStorage.getItem('companyId')
        const companyGroupId = JSON.parse(localStorage.getItem('group')).id
        const response = await axios.get(API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/bookings/' + item.id + '/pricing', config)
        const settings = response.data.settings || {}
        // The slot pricing lambda returns DECIMAL price as a string; the tier-priced subtotal
        // branches add price directly, so coerce once here (mirrors the booking drawer's cart line)
        const rows = Array.isArray(response.data.pricing)
          ? response.data.pricing.map(r => ({ ...r, price: parseFloat(r.price) || 0 }))
          : []
        const durations = Array.isArray(response.data.durations) ? response.data.durations : []
        const isCustom = settings.is_custom_pricing_enabled ? 1 : 0
        item.is_custom_pricing_enabled = isCustom
        if(isCustom){
          item.custom_pricing = rows
          item.slot_durations = durations
          item.enable_multiple_durations = settings.enable_multiple_durations ? 1 : 0
        } else {
          item.all_pricing = rows
          item.game_durations = durations
          item.game_enable_multiple_durations = settings.enable_multiple_durations ? 1 : 0
        }
        if(settings.pricing_type_id) item.pricing_type_id = settings.pricing_type_id
        item.cumulative_category_pricing = settings.cumulative_category_pricing ? 1 : 0
      } catch (err) {
        console.error('Failed to load slot pricing for cart item', item.id, err)
      }
    },
    // One ticket line per category the item sells under its selected duration
    seedTickets(item){
      const pricing = slotPricingRows(item, item.selected_duration_id)
      item.group_size = 0
      item.tickets = []
      const categories = this.getCategories(pricing)
      for(let n in pricing){
        if(!(_.find(item.tickets, { category_id: pricing[n].category_id }))){
          item.tickets.push({
            category_id: pricing[n].category_id,
            category: pricing[n].category.toLowerCase(),
            number_of_players: item.min_players_count,
            price: pricing[n].price,
            category_pricing: _.find(categories, {category_id: pricing[n].category_id}).pricing
          })
          item.group_size++
        }
      }
    },
    hasDurationPicker(item){
      const settings = slotDurationSettings(item)
      return settings.enabled && settings.durations.length > 1
    },
    durationOptionsFor(item){
      return durationPickerOptions(slotDurationSettings(item).durations)
    },
    onDurationChange(item, durationId){
      item.selected_duration_id = durationId
      this.seedTickets(item)
      this.onPlayerCountChange(item)
      localStorage.setItem('cart', JSON.stringify(this.cart))
    },
    getCategories(items){

      const groupedArray = [];

      items.forEach(item => {
        const { category_id, category, minimum_participants, default_participants } = item;

        // Find if the category_id already exists in groupedArray
        let group = groupedArray.find(g => g.category_id === category_id);

        if (!group) {
          // If it doesn't exist, create a new group
          group = {
            category_id: category_id,
            category: category,
            minimum_participants: minimum_participants,
            default_participants: default_participants,
            pricing: []
          };
          groupedArray.push(group);
        }

        group.pricing.push(item);
      });
      return groupedArray;
    },
    async getPaymentGateway(){
      // Wait for DOM to render after tab switch (v-if needs time to mount)
      await this.$nextTick()
      if(this.payment_settings.payment_gateway_id === 3){
        this.initializeStripe()
      }
      if(this.payment_settings.payment_gateway_id === 2){
        this.initializeSquare()
      }
    },
    getUser(){
      if(localStorage.getItem('customer')){
        this.user = JSON.parse(localStorage.getItem('customer'))
        this.getCredits(this.user)

        // Fetch Stripe customer data if applicable
        if (this.payment_settings.payment_gateway_id === 3 && this.user.end_user_id) {
          this.getStripeCustomer(this.user.end_user_id)
        }
      }
    },
    async getPaymentMethods(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/payment-methods'

      axios.get(url, config)
        .then((response) => {
          this.loading = false
          this.paymentOptions = response.data.payment_methods
          this.selectedPaymentOption = this.paymentOptions.length > 0 ? this.paymentOptions[0] : {}
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    }
  },
  mounted() {
    this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
    this.taxes = JSON.parse(localStorage.getItem('taxes')) || []
    this.fees = JSON.parse(localStorage.getItem('fees')) || []
    this.no_confirmation_email = false
    this.fetchInternalCustomFields()
    this.country = _.find(this.countries, { code: JSON.parse(localStorage.getItem('group')).country })
    this.payment_settings = JSON.parse(localStorage.getItem('payment_settings'))
    // Cast boolean settings
    if (this.payment_settings) {
      if (this.payment_settings.store_credit_card !== undefined) {
        this.payment_settings.store_credit_card = Boolean(this.payment_settings.store_credit_card)
      }
      if (this.payment_settings.create_customer !== undefined) {
        this.payment_settings.create_customer = Boolean(this.payment_settings.create_customer)
      }
      if (this.payment_settings.square_store_credit_card !== undefined) {
        this.payment_settings.square_store_credit_card = Boolean(this.payment_settings.square_store_credit_card)
      }
      if (this.payment_settings.square_create_customer !== undefined) {
        this.payment_settings.square_create_customer = Boolean(this.payment_settings.square_create_customer)
      }
    }
    if(this.payment_settings.payment_gateway_id === 3){
      this.loadStripe()
    }
    if(this.payment_settings.payment_gateway_id === 2){
      this.squareAppId = this.payment_settings.api_name
      this.squareLocationId = this.payment_settings.api_location
      this.loadSquare(this.payment_settings.is_live)
    }
    if(this.payment_settings.payment_gateway_id === 4){
      this.loadPaystack()
    }
    this.getPaymentMethods()
    this.getUser()
    this.getBasket()
  }
}
</script>

<style scoped>
/* Stored card visual is a deliberately dark credit-card graphic in both themes;
   keep its text legible in light mode instead of letting .text-white flip dark */
.white-content .stored-card .text-white { color: #fff !important; }
.white-content .stored-card .text-muted { color: rgba(255, 255, 255, 0.7) !important; }

img {
  width: 60px;
  height: 60px;
  -webkit-border-radius: 60px;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 60px;
  -moz-background-clip: padding;
  border-radius: 60px;
  background-clip: padding-box;
  margin: 7px 0 0 5px;
  float: left;
  background-size: cover;
  background-position: center center;
  margin-top: -7px;
  margin-bottom: -7px;
}

.payment-inline-alert {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.875rem;
  border: 1px solid rgba(253, 93, 147, 0.5);
  border-left: 3px solid #fd5d93;
  border-radius: 0.4285rem;
  background: rgba(253, 93, 147, 0.12);
  color: #fd5d93;
  font-size: 0.875rem;
}

.authorize-form-wrapper {
  max-width: 560px;
}

</style>
